import React, { Component } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import {
  refreshUsersAgents,
  ShowVisibleNextAtd,
  GetHistory,
  returnListCallQueue,
  DetailsAnotationsida,
  DetailsFileShared,
  CarregamentoCDR,
  DownloadFile,
  DetailsMarkstarida,
  SearchingHistoryData,
  RequestActiveCall,
  CarregamentoInteractions,
  SolicitarChamada,
  dbfileSize,
  InterationNotifier,
  RequestActiveCallSocketVoz,
  ActionRefreshNoAnswer,
  callbackChange,
  filaChange,
  tratamentoChange,
  arrayChange,
  retornoChange,
  ShowInfoDisplay,
} from "../actions";
import ICONPDFEXPORT from "../build/images/pdf.svg";
import "tippy.js/dist/tippy.css";
import _ from "lodash";
import Moment from "moment";
import JPG from "../build/images/jpg-file.png";
import XLS from "../build/images/media-icon.png";
import PDF from "../build/images/pdf-file.png";
import MP3 from "../build/images/mp3-file.png";
import Highlighter from "react-highlight-words";
import AVI from "../build/images/avi-file.png";
import WHATSAPP from "../build/images/whatsapp_new.svg";
import WEBCHAT from "../build/images/webchat_icon.svg";
import TELEGRANICON from "../build/images/telegram-new.svg";
import { RefreshNoAnswerCall } from "../actions/websocket";
import MicroModal from "micromodal";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import latinize from "latinize";
import QueueItem from "../components/queue-section/QueueItem";
import DeleteCallModal from "../modals/DeleteCallModal";
import PdfDocument from "../components/templates/PdfDocument";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import VIDEO from "../build/images/video.jpg";
import AUDIO from "../build/images/audio.svg";
import FOTO from "../build/images/foto.svg";
import DOC from "../build/images/doc.svg";

const { connection_platform } = require("../services/api");

const { meses, filtro_fila } = require("../services/data");

var gethostname = window.location.hostname;
var pathname = "";

var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;
var checkreply = false;
var statusIntervalCBack = "";
var checkCallBack = false;
var checkStatusAgente = "";
var keycount = 1;

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname != connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  // if(parseInt(connection_platform.port_apache_view_extern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
  // }
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  //if(parseInt(connection_platform.port_apache_view_intern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
  //}
}

MicroModal.init();

// function checkCallBackAuto(listqueue,time,qtdemax,statusagente){
//   let checklistCallqueue = false;
//   checkCallBack = true;

//   checkStatusAgente = statusagente;

//   statusIntervalCBack= setTimeout(() => {
//     listqueue.map(queue => {
//       if(parseInt(queue.callback_count)<parseInt(qtdemax) && checklistCallqueue ===false && parseInt(queue.status)===0){

//         checklistCallqueue = true;

//         let element =  document.getElementById("clickqueue_"+queue.queueid);
//         if (typeof(element) != 'undefined' && element != null){
//           document.getElementById("clickqueue_"+queue.queueid).click()
//         }
//       }
//     })
//     checkCallBack = false;

//   }, time*1000);
// };

function checkCallBackAuto(queueid, time, qtdemax, statusagente, queue) {
  let checklistCallqueue = false;
  //checkCallBack = true;

  checkStatusAgente = statusagente;

  statusIntervalCBack = setTimeout(() => {
    let element = document.getElementById("clickqueue_" + queueid);
    if (typeof element != "undefined" && element != null) {
      element.click();
    }

    checkCallBack = false;
  }, time * 1000);
}

function createJSON(item) {
  var mensagem_tratada = item.replace(/¿/gi, "\n");
  mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
  let valor = 1;
  try {
    mensagem_tratada =
      '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
    var obj = JSON.parse(mensagem_tratada);
    mensagem_tratada = obj[1][0].mensagem_tratada;
  } catch (e) {
    mensagem_tratada = item;
  }
  return mensagem_tratada;
}

function tratarMSG(item) {
  var mensagem_tratada = item;
  mensagem_tratada = item.replace(/¿/gi, "\n");
  mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
  let valor = 1;
  try {
    mensagem_tratada =
      '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
    var obj = JSON.parse(mensagem_tratada);
    mensagem_tratada = obj[1][0].mensagem_tratada;
  } catch (e) {
    mensagem_tratada = item;
    mensagem_tratada = mensagem_tratada.replace(/\r\n/gi, "ªª");
    mensagem_tratada = mensagem_tratada.replace(/\r\n/gi, "ªª");
    mensagem_tratada = mensagem_tratada.replace(/"/gi, "");
    mensagem_tratada = mensagem_tratada.replace(
      /[^A-ZÀ-Ú a-zà-ú 0-9 , . ? ! *  # ; : '-' _ + § ¿ { } ' " ª \\ \ ]/g,
      ""
    );
    mensagem_tratada =
      '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
    try {
      var obj = JSON.parse(mensagem_tratada);
      mensagem_tratada = obj[1][0].mensagem_tratada;
      mensagem_tratada = mensagem_tratada.replace(/ªª/gi, "\r\n");
    } catch (e) {
      mensagem_tratada = item;
    }
  }
  return mensagem_tratada;
}

function isJson(item) {
  item = typeof item != "string" ? JSON.stringify(item) : item;

  try {
    item = JSON.parse(item);
  } catch (e) {
    return false;
  }

  if (typeof item === "object" && item != null) {
    return true;
  }

  return false;
}

const mapDispatchToProps = (dispatch) => {
  return {
    testeeditar: (post, nome) => {
      dispatch(refreshUsersAgents(post, nome));
    },
    ReturningCallbackIn: (
      queueid,
      inforetorno,
      recvcount,
      cdrid,
      mediaid,
      srvin,
      caller,
      called,
      callback_count,
      status
    ) => {
      //ReturningCallback(queueid,inforetorno,recvcount,cdrid,mediaid,srvin,caller,called, callback_count)(dispatch);
      if (status != 2 || status != "2") {
        dispatch(
          returnListCallQueue(
            "",
            queueid,
            "2",
            parseInt(callback_count + 1),
            "você"
          )
        );
      }
    },
    SearchingHistory: (
      histstart,
      histend,
      idatendimento,
      telefone,
      idgroup
    ) => {
      dispatch(
        SearchingHistoryData(
          histstart,
          histend,
          idatendimento,
          telefone,
          idgroup
        )
      );
    },
    CarregamentoCDR: (queueid, idgroup) => {
      CarregamentoCDR(queueid, idgroup)(dispatch);
    },
    SolicitarChamada: (
      InfoUsers,
      scriptid,
      cdrid,
      mediaid,
      status,
      StatusAgent
    ) => {
      if (StatusAgent.allowCapture === false) {
        dispatch(InterationNotifier("Pausa não permite captura", "permission"));
      } else {
        dispatch(SolicitarChamada(InfoUsers, scriptid, cdrid, mediaid));
      }
    },
    CarregamentoInteractions: (cdr) => {
      CarregamentoInteractions(cdr)(dispatch);
    },
    ShowVisibleNextAtdIn: (post, temp) => {
      dispatch(ShowVisibleNextAtd(post, temp));
    },
    DetailsAnotationsida: (datainit, datafim, idcriticidade, telefone) => {
      dispatch(
        DetailsAnotationsida(datainit, datafim, idcriticidade, telefone)
      );
    },
    DetailsFileSharedIn: (datainit, datafim, formats, midias, telefone) => {
      dispatch(DetailsFileShared(datainit, datafim, formats, midias, telefone));
    },
    DetailsMarkstarida: (datainit, datafim, telefone) => {
      dispatch(DetailsMarkstarida(datainit, datafim, telefone));
    },
    DonwloadFileIn: (url, name) => {
      DownloadFile(url, name)(dispatch);
    },
    ClearHistory: (post) => {
      dispatch(GetHistory([]));
    },
    callbackChange: (post) => {
      dispatch(callbackChange(post));
    },
    filaChange: (post) => {
      dispatch(filaChange(post));
    },
    tratamentoChange: (post) => {
      dispatch(tratamentoChange(post));
    },
    retornoChange: (post) => {
      dispatch(retornoChange(post));
    },
    arrayChange: (post) => {
      dispatch(arrayChange(post));
    },
    ShowInfoDisplay: (post) => {
      dispatch(ShowInfoDisplay(post));
    },
    RequestActiveCall: (
      outband,
      infouser,
      trunk,
      mediaid,
      calledDigitado,
      addtech,
      scriptrunk,
      operator,
      returning,
      queueid,
      recvcount,
      cbackcount,
      idgrupo_transb,
      cdrold
    ) => {
      dispatch(
        RequestActiveCall(
          outband,
          infouser,
          trunk,
          mediaid,
          calledDigitado,
          addtech,
          scriptrunk,
          operator,
          returning,
          queueid,
          recvcount,
          cbackcount,
          idgrupo_transb,
          cdrold
        )
      );
    },
    InterationNotifier: (text, type) => {
      dispatch(InterationNotifier(text, type));
    },
    RequestActiveCallSocketVoz: (
      outband,
      infouser,
      trunk,
      mediaid,
      chamado,
      addtech,
      scriptrunk,
      operator,
      returning,
      queueid,
      recvcount,
      callback_count,
      tech,
      idgrupo_rota,
      idgrupo_transb,
      ipcurrent,
      cdrid,
      rotaencontrada
    ) => {
      dispatch(
        RequestActiveCallSocketVoz(
          outband,
          infouser,
          trunk,
          mediaid,
          chamado,
          addtech,
          scriptrunk,
          operator,
          returning,
          queueid,
          recvcount,
          callback_count,
          tech,
          idgrupo_rota,
          idgrupo_transb,
          ipcurrent,
          cdrid,
          rotaencontrada
        )
      );
    },
    PropsRefreshNoAnswer: (cdrid, queueid, infousers) => {
      dispatch(ActionRefreshNoAnswer(queueid));
      RefreshNoAnswerCall(cdrid, queueid, infousers);
    },
  };
};

const mapStateToProps = (state) => {
  return {
    listCallQueue: state.listcallqueue,
    InfoUsers: state.informationusers,
    PermissionRouter: state.routergroups,
    StatusAgent: state.status,
    OutBandService: state.outservices,
    DisplayNextAtd: state.displaynextatd,
    DetailsAnotations: state.detailsanotations,
    CriticidadesAnotacoes: state.criticalitys,
    IPCurrent: state.ipcurrent,
    DetailsMarkstar: state.detailsmarkstars,
    DetailsFileShared: state.detailsfileshared,
    History: state.history,
    CallBack: state.callback,
    AtdSimult: state.atdsimult,
    Filters: state.filters,
    ContactId: state.atendimento,
  };
};

class Queue extends Component {
  constructor(props) {
    super(props);
    var storageMedia = localStorage.getItem("clients_queue_media") || [];
    if (storageMedia.length !== 0) {
      storageMedia = storageMedia.split(",").map(Number);
    }
    this.SearchHistoryQueue = this.SearchHistoryQueue.bind(this);
    this.state = {
      buttonFilterQueue: false,
      buttonDetails: false,
      buttonDetailsIn: false,
      searchText: "",
      history: [],
      filterQueue: [],
      keyQueue: [],
      visible: "",
      auxkeyQueue: [],
      typequeue: filtro_fila,
      callqueue: [],
      typemedia: storageMedia,
      expandQueue: [],
      DescAnotacoes: [],
      critSelec: "Todos",
      iconCrit: "",
      idCrit: "",
      buttonShowCriticits: false,
      detailsAnotations: [],
      totalAnotations: 0,
      detailsMarkstar: [],
      detailsFileShared: [],
      totalMarkstar: 0,
      totalFiles: 0,
      buttonLearnMore: false,
      expandLearn: [],
      optionsActionsFile: [],
      buttonShowOptionsAnot: false,
      buttonShowInsertAnot: false,
      SelecCritic: "Selecione",
      defaultValueFormat: "Todos",
      defaultValueMidias: "Todos",
      totalAnotations: 0,
      totalFiles: 0,
      totalMarkstar: 0,
      totalhistory: 0,
      nameCli: "Cliente",
      scrollEnd: 30,
      isOpen: false,
      cliente: "",
      midias: [],
    };

    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.DisplayDetails = this.DisplayDetails.bind(this);
    this.DisplayAnottations = this.DisplayAnottations.bind(this);
    this.change = this.change.bind(this);
  }

  componentDidMount() {
    this.setState({
      RetractExpand: "Expandir todos",
      expandcollapse: "expand",
      queueid: -1,
      filter: "",
      unfold: "unfold_more",
    });
  }

  handleKeyUp(inf) {
    var elems = document.getElementsByTagName("mark");
    var tam = elems.length;

    if (tam >= this.state.arrowterm + 1) {
      elems[this.state.arrowterm].scrollIntoView(false);
      if (inf == "less") {
        if (this.state.arrowterm != 0) {
          this.state.arrowterm = this.state.arrowterm - 1;
        }
      } else {
        this.state.arrowterm = this.state.arrowterm + 1;
      }
    } else {
      if (elems[this.state.arrowterm]) {
        this.state.arrowterm = 0;
        elems[this.state.arrowterm].scrollIntoView(false);
      }
    }
  }

  SearchHistoryQueue(idatendimento, telefone) {
    let histstart = this.datahistoryinitqueue.value;
    let histend = this.datahistoryfimqueue.value;
    let idgroup = this.props.InfoUsers.idgroup;
    this.props.SearchingHistory(
      histstart,
      histend,
      33,
      this.state.numberqueue,
      idgroup
    );
    this.setState({ datapdfend: histend, datapdfinit: histend });
  }

  DisplayFilterQueue(e) {
    // e.preventDefault();
    this.setState({ buttonFilterQueue: !this.state.buttonFilterQueue });
  }

  DisplayDetails(e) {
    e.preventDefault();
    this.setState({ buttonDetails: !this.state.buttonDetails });
    let newState = this.state.buttonDetails
      ? {
          RetractExpand: "Expandir todos",
          expandcollapse: "expand",
          unfold: "unfold_more",
        }
      : {
          RetractExpand: "Retrair Todos",
          expandcollapse: "collapse",
          unfold: "unfold_less",
          expandQueue: [],
        };
    this.setState(newState);
  }

  DisplayDetailsIn(event, idqueue) {
    event.preventDefault();
    this.setState({
      buttonDetailsIn: !this.state.buttonDetailsIn,
      queueid: idqueue,
    });
  }

  DisplayAnottations(event, idqueue) {
    event.preventDefault();
    this.setState({ queueid: idqueue });
  }

  change(e) {}

  get_filesize(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open("HEAD", url, true);

    xhr.onreadystatechange = function () {
      if (this.readyState == this.DONE) {
        callback = callback(parseInt(xhr.getResponseHeader("Content-Length")));
      }
    };
    xhr.send();
  }

  changeQueue(e) {
    this.setState({ filterQueue: e.target.value });

    if (e.target.value != "") {
      this.setState({ keyQueue: [] });
    }
    if (e.target.value === "") {
      this.setState({ keyQueue: this.state.auxkeyQueue });
    }
  }

  getFilterQueue(e, idqueue) {
    let filtro = this.state.typequeue;
    if (e.target.checked) {
      this.setState({
        typequeue: this.state.typequeue.concat([idqueue]),
      });
      localStorage.setItem("filtro_fila", filtro.concat([idqueue]));
      this.saveTostorage(idqueue, true);
      this.props.arrayChange(filtro.concat([idqueue]));
    } else {
      this.setState({
        typequeue: this.state.typequeue.filter(function (val) {
          return val != idqueue;
        }),
      });
      localStorage.setItem(
        "filtro_fila",
        filtro.filter(function (val) {
          return val != idqueue;
        })
      );
      this.saveTostorage(idqueue, false);
      this.props.arrayChange(
        filtro.filter(function (val) {
          return val != idqueue;
        })
      );
    }
  }

  saveTostorage(idqueue, value) {
    switch (idqueue) {
      case "0":
        localStorage.setItem("fila_checkbox_callback", value);
        this.props.callbackChange(value);
        break;
      case "1":
        localStorage.setItem("fila_checkbox_espera", value);
        this.props.filaChange(value);
        break;
      case "2":
        localStorage.setItem("fila_checkbox_em_tratamento", value);
        this.props.tratamentoChange(value);
        break;
      case "5":
        localStorage.setItem("fila_checkbox_retorno", value);
        this.props.retornoChange(value);
        break;
    }
  }

  getFilterMedia(e, idmedia) {
    let filtermediastorage = [];
    if (e.target.checked) {
      this.setState({
        typemedia: this.state.typemedia.concat([idmedia]),
      });
      filtermediastorage = this.state.typemedia.concat([idmedia]);
    } else {
      this.setState({
        typemedia: this.state.typemedia.filter(function (val) {
          return val != idmedia;
        }),
      });
      filtermediastorage = this.state.typemedia.filter(function (val) {
        return val != idmedia;
      });
    }
    localStorage.setItem("clients_queue_media", filtermediastorage);
  }

  DisplayDetailsIn(event, idqueue) {
    event.preventDefault();
    this.setState({
      buttonDetailsIn: !this.state.buttonDetailsIn,
      queueid: idqueue,
    });
  }

  checkExpandQueue = (e, idqueue) => {
    var checkClick =
      this.state.expandQueue.indexOf(idqueue) != -1 ? true : false;

    if (!checkClick) {
      this.setState({
        expandQueue: this.state.expandQueue.concat([idqueue]),
      });
    } else {
      this.setState({
        expandQueue: this.state.expandQueue.filter(function (val) {
          return val != idqueue;
        }),
      });
    }
  };

  buttonSearchAnotation(e) {
    e.preventDefault();
    var erro = 0;
    const datainit = this.dataInitqueue.value;
    const datafim = this.dataFimqueue.value;
    const idcriticidade = this.state.idCrit;

    let comparation = Moment(datainit).isBefore(datafim);

    if (datainit == "") var erro = 1;

    if (datafim == "") var erro = 1;

    if (comparation === false) {
      var erro = 1;
      if (datainit === datafim) {
        var erro = 0;
      }
    }

    if (erro === 0) {
      this.props.DetailsAnotationsida(
        datainit,
        datafim,
        idcriticidade,
        this.state.numberqueue
      );
    }
  }

  buttonSearchFileCompart(e) {
    e.preventDefault();
    var erro = 0;
    const datainit = this.timearqinitqueue.value;
    const datafim = this.timearqfimqueue.value;
    const formats = this.mimetypeids.value;
    const midias = this.midias.value;

    var comparation = Moment(datainit).isBefore(datafim);

    if (datainit == "") var erro = 1;

    if (datafim == "") var erro = 1;

    if (formats == "") var erro = 1;

    if (midias == "") var erro = 1;

    if (comparation === false) {
      var erro = 1;
      if (datainit === datafim) {
        var erro = 0;
      }
    }

    if (erro === 0) {
      this.props.DetailsFileSharedIn(
        datainit,
        datafim,
        formats,
        midias,
        this.state.numberqueue
      );
    }
  }

  SolicitarChamadaAtiva = (
    e,
    permrouter,
    mediaid,
    status,
    infouser,
    chamado,
    outband,
    queue,
    AtdSimult,
    ipcurrent,
    statusAgent
  ) => {
    if (mediaid === 2) mediaid = 1;

    if (this.props.ContactId.length !== 0) {
      localStorage.setItem(
        "current-service",
        this.props.ContactId.idatendimento
      );
    }

    if (statusAgent.allowCall === false) {
      this.props.InterationNotifier("Pausa não permite ativo", "permission");
      return true;
    }

    if (document.getElementById("chat-message"))
      document.getElementById("chat-message").innerText = "";
    var existeRota = false;
    var trunk = "";
    var addtech = "";
    var scriptrunk = "";
    var operator = "";
    var teste = [];
    var idgrupo_rota = "";
    var checkAtd = false;
    var tech = "";

    var idgrupo_transb = "";
    var rotaDefault = false;
    var trunkDef = "";
    var addtechDef = "";
    var scriptrunkDef = "";
    var operatorDef = "";
    var techDef = "";
    var idgrupo_rotaDef = "";
    var idgrupo_transbDef = "";
    var rotaAlternativa = false;
    var tipochamada = 0;
    if (
      permrouter[0].areacodeid != "undefined" &&
      permrouter[0].areacodeid != ""
    ) {
      var DDD = permrouter[0].areacodeid;
      var DDDPadrao = permrouter[0].areacodeid;
    } else {
      var DDD = "71";
      var DDDPadrao = "71";
    }
    var dddValidado = "";

    var calledDigitado = chamado;
    var rotaencontrada = false;
    var checkRota = false;
    var valorfixo = [1, 2, 3, 4];
    var valormovel = [5, 6, 7, 8, 9];
    //var caracterAdicional = "";
    if (connection_platform.remove_digits || parseInt(mediaid) !== 1) {
      if (
        chamado[0] === "0" &&
        chamado.substr(0, 2) != "00" &&
        chamado.substr(0, 4) != "0800"
      ) {
        //caracterAdicional = chamado.substr(0,1);
        chamado = chamado.substr(1, chamado.length - 1);
      }
    }

    if (
      (chamado.length === 12 || chamado.length === 13) &&
      chamado.substr(0, 2) != "00"
    ) {
      if (
        chamado.substr(0, 2) === "55" &&
        (mediaid === 5 || mediaid === "5") &&
        chamado.length > 11
      ) {
        chamado = chamado.substr(2, chamado.length - 1);
        calledDigitado = calledDigitado.substr(2, calledDigitado.length - 1);
      }

      dddValidado = chamado.substr(2, 2);

      if (
        !connection_platform.remove_digits &&
        parseInt(mediaid) === 1 &&
        chamado.startsWith("0")
      ) {
        dddValidado = chamado.substr(1, 2);
      }

      if (parseInt(dddValidado) != parseInt(DDDPadrao)) {
        if (valorfixo.indexOf(parseInt(chamado[4])) > -1) {
          if (mediaid == 1) tipochamada = 3;
          else if (mediaid == 5) tipochamada = 17;
          else if (mediaid == 8) tipochamada = 19;
          else if (mediaid === 4) tipochamada = 18;
          else if (mediaid === 6) tipochamada = 20;
          else if (mediaid === 9) tipochamada = 21;
          else if (mediaid === 10) tipochamada = 23;
          else if (mediaid === 3) tipochamada = 22;
          else if (mediaid === 2) tipochamada = 24;
        } else if (valormovel.indexOf(parseInt(chamado[4])) > -1) {
          if (mediaid == 1) tipochamada = 4;
          else if (mediaid == 5) tipochamada = 17;
          else if (mediaid == 8) tipochamada = 19;
          else if (mediaid === 4) tipochamada = 18;
          else if (mediaid === 6) tipochamada = 20;
          else if (mediaid === 9) tipochamada = 21;
          else if (mediaid === 10) tipochamada = 23;
          else if (mediaid === 3) tipochamada = 22;
          else if (mediaid === 2) tipochamada = 24;
        }
      } else if (parseInt(dddValidado) == parseInt(DDDPadrao)) {
        if (valorfixo.indexOf(parseInt(chamado[4])) > -1) {
          if (mediaid == 1) tipochamada = 1;
          else if (mediaid == 5) tipochamada = 17;
          else if (mediaid == 8) tipochamada = 19;
          else if (mediaid === 4) tipochamada = 18;
          else if (mediaid === 6) tipochamada = 20;
          else if (mediaid === 9) tipochamada = 21;
          else if (mediaid === 10) tipochamada = 23;
          else if (mediaid === 3) tipochamada = 22;
          else if (mediaid === 2) tipochamada = 24;
        } else if (valormovel.indexOf(parseInt(chamado[4])) > -1) {
          if (mediaid == 1) tipochamada = 2;
          else if (mediaid == 5) tipochamada = 17;
          else if (mediaid == 8) tipochamada = 19;
          else if (mediaid === 4) tipochamada = 18;
          else if (mediaid === 6) tipochamada = 20;
          else if (mediaid === 9) tipochamada = 21;
          else if (mediaid === 10) tipochamada = 23;
          else if (mediaid === 3) tipochamada = 22;
          else if (mediaid === 2) tipochamada = 24;
        }
      }
    }
    if (
      (chamado.length === 10 || chamado.length === 11) &&
      chamado.substr(0, 3) != "800" &&
      chamado.substr(0, 2) != "00"
    ) {
      DDD = chamado.substr(0, 2);
      chamado = chamado.substr(2, chamado.length - 1);
      if (chamado.length === 8 && parseInt(chamado.substr(0, 1)) >= 6) {
        if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9) {
          chamado = "9" + chamado;
        }
      }

      if (
        parseInt(parseInt(DDD)) != parseInt(DDDPadrao) &&
        chamado.substr(0, 2) != "00"
      ) {
        if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
          if (mediaid == 1) tipochamada = 3;
          else if (mediaid == 5) tipochamada = 17;
          else if (mediaid == 8) tipochamada = 19;
          else if (mediaid === 4) tipochamada = 18;
          else if (mediaid === 6) tipochamada = 20;
          else if (mediaid === 9) tipochamada = 21;
          else if (mediaid === 10) tipochamada = 23;
          else if (mediaid === 3) tipochamada = 22;
          else if (mediaid === 2) tipochamada = 24;
        } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
          if (mediaid == 1) tipochamada = 4;
          else if (mediaid == 5) tipochamada = 17;
          else if (mediaid == 8) tipochamada = 19;
          else if (mediaid === 4) tipochamada = 18;
          else if (mediaid === 6) tipochamada = 20;
          else if (mediaid === 9) tipochamada = 21;
          else if (mediaid === 10) tipochamada = 23;
          else if (mediaid === 3) tipochamada = 22;
          else if (mediaid === 2) tipochamada = 24;
        }
      } else if (parseInt(DDD) == parseInt(DDDPadrao)) {
        if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
          if (mediaid == 1) tipochamada = 1;
          else if (mediaid == 5) tipochamada = 17;
          else if (mediaid == 8) tipochamada = 19;
          else if (mediaid === 4) tipochamada = 18;
          else if (mediaid === 6) tipochamada = 20;
          else if (mediaid === 9) tipochamada = 21;
          else if (mediaid === 10) tipochamada = 23;
          else if (mediaid === 3) tipochamada = 22;
          else if (mediaid === 2) tipochamada = 24;
        } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
          if (mediaid == 1) tipochamada = 2;
          else if (mediaid == 5) tipochamada = 17;
          else if (mediaid == 8) tipochamada = 19;
          else if (mediaid === 4) tipochamada = 18;
          else if (mediaid === 6) tipochamada = 20;
          else if (mediaid === 9) tipochamada = 21;
          else if (mediaid === 10) tipochamada = 23;
          else if (mediaid === 3) tipochamada = 22;
          else if (mediaid === 2) tipochamada = 24;
        }
      }
      if (mediaid !== 8) {
        chamado = DDD + chamado;
        calledDigitado = DDD + calledDigitado;
      }
    } else if (chamado.length === 8 || chamado.length === 9) {
      if (chamado.length === 8 && parseInt(chamado.substr(0, 1)) >= 6) {
        if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9) {
          chamado = "9" + chamado;
        }
      }

      if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
        if (mediaid == 1) tipochamada = 1;
        else if (mediaid == 5) tipochamada = 17;
        else if (mediaid == 8) tipochamada = 19;
        else if (mediaid === 4) tipochamada = 18;
        else if (mediaid === 6) tipochamada = 20;
        else if (mediaid === 9) tipochamada = 21;
        else if (mediaid === 10) tipochamada = 23;
        else if (mediaid === 3) tipochamada = 22;
        else if (mediaid === 2) tipochamada = 24;
      } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
        if (mediaid == 1) tipochamada = 2;
        else if (mediaid == 5) tipochamada = 17;
        else if (mediaid == 8) tipochamada = 19;
        else if (mediaid === 4) tipochamada = 18;
        else if (mediaid === 6) tipochamada = 20;
        else if (mediaid === 9) tipochamada = 21;
        else if (mediaid === 10) tipochamada = 23;
        else if (mediaid === 3) tipochamada = 22;
        else if (mediaid === 2) tipochamada = 24;
      }
      if (mediaid !== 1 && mediaid !== 8) {
        chamado = DDD + chamado;
        calledDigitado = DDD + calledDigitado;
      }
    } else if (chamado.substr(0, 3) == "800") {
      //chamado = '0'+chamado;
      tipochamada = 8;
    } else if (chamado.substr(0, 2) == "00") {
      if (mediaid == 1) tipochamada = 5;
      else if (mediaid == 5) tipochamada = 17;
      else if (mediaid == 8) tipochamada = 19;
      else if (mediaid === 4) tipochamada = 18;
      else if (mediaid === 6) tipochamada = 20;
      else if (mediaid === 9) tipochamada = 21;
      else if (mediaid === 10) tipochamada = 23;
      else if (mediaid === 3) tipochamada = 22;
      else if (mediaid === 2) tipochamada = 24;
    } else {
      permrouter.map((result) => {
        if (result.calltypeid == 11) {
          if (
            parseInt(chamado) >= parseInt(result.partialnumber) &&
            parseInt(chamado) <= parseInt(result.partialnumber_end)
          ) {
            tipochamada = 11;
          }
        } else if (result.calltypeid == 6) {
          if (parseInt(chamado) === parseInt(result.partialnumber)) {
            tipochamada = 6;
          }
        }
      });
    }

    if (mediaid === 4) tipochamada = 18;
    else if (mediaid === 6) tipochamada = 20;
    else if (mediaid === 9) tipochamada = 21;
    else if (mediaid === 10) tipochamada = 23;
    else if (mediaid === 3) tipochamada = 22;
    else if (mediaid === 2) tipochamada = 24;

    if (queue.status === "0") {
      // if (parseInt(mediaid) == 1) {
      permrouter.map((result) => {
        if (parseInt(result.idmidia) === parseInt(mediaid)) {
          if (parseInt(tipochamada) == result.calltypeid) {
            if (parseInt(tipochamada) == 1) {
              if (
                (parseInt(chamado) >=
                  parseInt(result.areacode + result.partialnumber) &&
                  chamado <=
                    parseInt(result.areacode + result.partialnumber_end)) ||
                parseInt(chamado) ==
                  parseInt(result.areacode + result.partialnumber)
              ) {
                trunk = result.idtrunk;
                addtech = result.addtech;
                scriptrunk = result.scripttrunk;
                operator = result.operator;
                tech = result.tech;
                idgrupo_rota = result.idgrupo_rota;
                idgrupo_transb = result.idgrupo_transb;
                rotaencontrada = true;
                checkRota = true;
                existeRota = true;
              } else if (
                (parseInt(chamado.substr(parseInt(chamado.length) - 8, 4)) >=
                  parseInt(result.partialnumber) &&
                  chamado.substr(parseInt(chamado.length) - 8, 4) <=
                    parseInt(result.partialnumber_end)) ||
                parseInt(chamado.substr(parseInt(chamado.length) - 8, 4)) ==
                  parseInt(result.partialnumber)
              ) {
                trunk = result.idtrunk;
                addtech = result.addtech;
                scriptrunk = result.scripttrunk;
                operator = result.operator;
                tech = result.tech;
                idgrupo_rota = result.idgrupo_rota;
                idgrupo_transb = result.idgrupo_transb;
                rotaencontrada = true;
                checkRota = true;
                existeRota = true;
              } else if (
                result.operator !== null &&
                result.operator != "" &&
                result.areacode ===
                  parseInt(chamado.substr(parseInt(chamado.length) - 10, 2))
              ) {
                trunk = result.idtrunk;
                addtech = result.addtech;
                scriptrunk = result.scripttrunk;
                operator = result.operator;
                tech = result.tech;
                idgrupo_rota = result.idgrupo_rota;
                idgrupo_transb = result.idgrupo_transb;
                rotaencontrada = true;
                existeRota = true;
                checkRota = true;
              } else if (rotaencontrada == false) {
                trunk = result.idtrunk;
                addtech = result.addtech;
                scriptrunk = result.scripttrunk;
                operator = result.operator;
                tech = result.tech;
                idgrupo_rota = result.idgrupo_rota;
                idgrupo_transb = result.idgrupo_transb;
                existeRota = true;
                checkRota = true;
              }
            } else if (parseInt(tipochamada) == 2) {
              if (
                (parseInt(chamado) >=
                  parseInt(result.areacode + result.partialnumber) &&
                  chamado <=
                    parseInt(result.areacode + result.partialnumber_end)) ||
                parseInt(chamado) ==
                  parseInt(result.areacode + result.partialnumber)
              ) {
                trunk = result.idtrunk;
                addtech = result.addtech;
                scriptrunk = result.scripttrunk;
                operator = result.operator;
                tech = result.tech;
                idgrupo_rota = result.idgrupo_rota;
                idgrupo_transb = result.idgrupo_transb;
                rotaencontrada = true;
                checkRota = true;
                existeRota = true;
              } else if (
                (parseInt(chamado.substr(parseInt(chamado.length) - 8, 4)) >=
                  parseInt(result.partialnumber) &&
                  chamado.substr(parseInt(chamado.length) - 8, 4) <=
                    parseInt(result.partialnumber_end)) ||
                parseInt(chamado.substr(parseInt(chamado.length) - 8, 4)) ==
                  parseInt(result.partialnumber)
              ) {
                trunk = result.idtrunk;
                addtech = result.addtech;
                scriptrunk = result.scripttrunk;
                operator = result.operator;
                tech = result.tech;
                idgrupo_rota = result.idgrupo_rota;
                idgrupo_transb = result.idgrupo_transb;
                rotaencontrada = true;
                checkRota = true;
                existeRota = true;
              } else if (
                result.operator !== null &&
                result.operator != "" &&
                result.areacode ===
                  parseInt(chamado.substr(parseInt(chamado.length) - 11, 2))
              ) {
                trunk = result.idtrunk;
                addtech = result.addtech;
                scriptrunk = result.scripttrunk;
                operator = result.operator;
                tech = result.tech;
                idgrupo_rota = result.idgrupo_rota;
                idgrupo_transb = result.idgrupo_transb;
                rotaencontrada = true;
                existeRota = true;
                checkRota = true;
              } else if (rotaencontrada == false) {
                trunk = result.idtrunk;
                addtech = result.addtech;
                scriptrunk = result.scripttrunk;
                operator = result.operator;
                tech = result.tech;
                idgrupo_rota = result.idgrupo_rota;
                idgrupo_transb = result.idgrupo_transb;
                existeRota = true;
                checkRota = true;
              }
            } else if (parseInt(tipochamada) == 3) {
              if (
                (parseInt(chamado) >=
                  parseInt(result.areacode + result.partialnumber) &&
                  chamado <=
                    parseInt(result.areacode + result.partialnumber_end)) ||
                parseInt(chamado) ==
                  parseInt(result.areacode + result.partialnumber)
              ) {
                trunk = result.idtrunk;
                addtech = result.addtech;
                scriptrunk = result.scripttrunk;
                operator = result.operator;
                tech = result.tech;
                idgrupo_rota = result.idgrupo_rota;
                idgrupo_transb = result.idgrupo_transb;
                rotaencontrada = true;
                checkRota = true;
                existeRota = true;
              } else if (
                (parseInt(chamado.substr(parseInt(chamado.length) - 8, 4)) >=
                  parseInt(result.partialnumber) &&
                  chamado.substr(parseInt(chamado.length) - 8, 4) <=
                    parseInt(result.partialnumber_end)) ||
                parseInt(chamado.substr(parseInt(chamado.length) - 8, 4)) ==
                  parseInt(result.partialnumber)
              ) {
                trunk = result.idtrunk;
                addtech = result.addtech;
                scriptrunk = result.scripttrunk;
                operator = result.operator;
                tech = result.tech;
                idgrupo_rota = result.idgrupo_rota;
                idgrupo_transb = result.idgrupo_transb;
                rotaencontrada = true;
                checkRota = true;
                existeRota = true;
              } else if (rotaencontrada == false) {
                trunk = result.idtrunk;
                addtech = result.addtech;
                scriptrunk = result.scripttrunk;
                operator = result.operator;
                tech = result.tech;
                idgrupo_rota = result.idgrupo_rota;
                idgrupo_transb = result.idgrupo_transb;
                existeRota = true;
                checkRota = true;
              }
            } else if (parseInt(tipochamada) == 4) {
              if (
                (parseInt(chamado) >=
                  parseInt(result.areacode + result.partialnumber) &&
                  chamado <=
                    parseInt(result.areacode + result.partialnumber_end)) ||
                parseInt(chamado) ==
                  parseInt(result.areacode + result.partialnumber)
              ) {
                trunk = result.idtrunk;
                addtech = result.addtech;
                scriptrunk = result.scripttrunk;
                operator = result.operator;
                tech = result.tech;
                idgrupo_rota = result.idgrupo_rota;
                idgrupo_transb = result.idgrupo_transb;
                rotaencontrada = true;
                checkRota = true;
                existeRota = true;
              } else if (
                (parseInt(chamado.substr(parseInt(chamado.length) - 8, 4)) >=
                  parseInt(result.partialnumber) &&
                  chamado.substr(parseInt(chamado.length) - 8, 4) <=
                    parseInt(result.partialnumber_end)) ||
                parseInt(chamado.substr(parseInt(chamado.length) - 8, 4)) ==
                  parseInt(result.partialnumber)
              ) {
                trunk = result.idtrunk;
                addtech = result.addtech;
                scriptrunk = result.scripttrunk;
                operator = result.operator;
                tech = result.tech;
                idgrupo_rota = result.idgrupo_rota;
                idgrupo_transb = result.idgrupo_transb;
                rotaencontrada = true;
                checkRota = true;
                existeRota = true;
              } else if (rotaencontrada == false) {
                trunk = result.idtrunk;
                addtech = result.addtech;
                scriptrunk = result.scripttrunk;
                operator = result.operator;
                tech = result.tech;
                idgrupo_rota = result.idgrupo_rota;
                idgrupo_transb = result.idgrupo_transb;
                existeRota = true;
                checkRota = true;
              }
            } else if (parseInt(tipochamada) == 5) {
              if (rotaencontrada == false) {
                trunk = result.idtrunk;
                addtech = result.addtech;
                scriptrunk = result.scripttrunk;
                operator = result.operator;
                tech = result.tech;
                idgrupo_rota = result.idgrupo_rota;
                idgrupo_transb = result.idgrupo_transb;
                rotaencontrada = true;
                existeRota = true;
                checkRota = true;
              }
            } else if (parseInt(tipochamada) == 8) {
              if (rotaencontrada == false) {
                trunk = result.idtrunk;
                addtech = result.addtech;
                scriptrunk = result.scripttrunk;
                operator = result.operator;
                tech = result.tech;
                idgrupo_rota = result.idgrupo_rota;
                idgrupo_transb = result.idgrupo_transb;
                rotaencontrada = true;
                existeRota = true;
                checkRota = true;
              }
            } else if (
              parseInt(tipochamada) != 5 &&
              chamado.substr(0, 2) == "00" &&
              parseInt(result.operator) == parseInt(chamado.substr(0, 2))
            ) {
              trunk = result.idtrunk;
              addtech = result.addtech;
              scriptrunk = result.scripttrunk;
              operator = "";
              tech = result.tech;
              idgrupo_rota = result.idgrupo_rota;
              idgrupo_transb = result.idgrupo_transb;
              rotaencontrada = true;
              checkRota = true;
              existeRota = true;
            } else if (parseInt(tipochamada) == 11) {
              permrouter.map((result) => {
                if (result.calltypeid == 11) {
                  if (
                    parseInt(chamado) >= parseInt(result.partialnumber) &&
                    parseInt(chamado) <= parseInt(result.partialnumber_end)
                  ) {
                    trunk = result.idtrunk;
                    addtech = result.addtech;
                    scriptrunk = result.scripttrunk;
                    operator = "";
                    tech = result.tech;
                    idgrupo_rota = result.idgrupo_rota;
                    idgrupo_transb = result.idgrupo_transb;
                    rotaencontrada = true;
                    checkRota = true;
                    existeRota = true;
                    checkRota = true;
                  }
                }
              });
            } else if (parseInt(tipochamada) == 6) {
              permrouter.map((result) => {
                if (result.calltypeid == 6) {
                  if (parseInt(chamado) === parseInt(result.partialnumber)) {
                    trunk = result.idtrunk;
                    addtech = result.addtech;
                    scriptrunk = result.scripttrunk;
                    operator = "";
                    tech = result.tech;
                    idgrupo_rota = result.idgrupo_rota;
                    idgrupo_transb = result.idgrupo_transb;
                    rotaencontrada = true;
                    existeRota = true;
                    checkRota = true;
                  }
                }
              });
            } else {
              if (rotaencontrada == false) {
                trunk = result.idtrunk;
                addtech = result.addtech;
                scriptrunk = result.scripttrunk;
                operator = result.operator;
                tech = result.tech;
                idgrupo_rota = result.idgrupo_rota;
                idgrupo_transb = result.idgrupo_transb;
                rotaencontrada = true;
                existeRota = true;
              }
            }
          }
        }
      });

      AtdSimult.map((atend) => {
        if (
          String(atend.telefone) === String(chamado) &&
          parseInt(mediaid) === parseInt(atend.idmidia)
        )
          checkAtd = true;
      });
      if (checkAtd == false) {
        if (existeRota == true) {
          var queueid = queue.queueid;
          var recvcount = queue.recv_count;
          var cdrid = queue.cdrid;
          var callback_count = queue.callback_count;
          var srvin = queue.serviceinid;
          var caller = queue.caller;
          var called = queue.called;
          var cbackcount = queue.callback_count;
          var status = queue.status;
          if (parseInt(mediaid) == 1) {
            this.props.RequestActiveCallSocketVoz(
              outband,
              infouser,
              trunk,
              mediaid,
              chamado,
              addtech,
              scriptrunk,
              operator,
              true,
              queueid,
              recvcount,
              callback_count,
              tech,
              idgrupo_rota,
              idgrupo_transb,
              ipcurrent,
              cdrid,
              checkRota
            );
            this.props.ReturningCallbackIn(
              queueid,
              true,
              recvcount,
              cdrid,
              mediaid,
              srvin,
              caller,
              called,
              cbackcount,
              status
            );
            this.props.ShowInfoDisplay("Clientes");
          } else {
            this.props.RequestActiveCall(
              outband,
              infouser,
              trunk,
              mediaid,
              chamado,
              addtech,
              scriptrunk,
              operator,
              true,
              queueid,
              recvcount,
              callback_count,
              idgrupo_rota,
              cdrid
            );
            this.props.ReturningCallbackIn(
              queueid,
              true,
              recvcount,
              cdrid,
              mediaid,
              srvin,
              caller,
              called,
              callback_count
            );
            this.props.ShowInfoDisplay("Clientes");
          }
        } else {
          this.props.InterationNotifier("Sem rota de sa&iacute;da!", "call");
        }
      } else {
        this.props.InterationNotifier(
          "Este cliente já está sendo atendido por você",
          "call"
        );
      }
    } else {
      this.props.InterationNotifier(
        "Chamada já está sendo retornada por " + queue.username,
        "call"
      );
    }
  };

  ShowVisible() {
    this.props.ShowVisibleNextAtdIn(false, false);
    // MicroModal.show('modal__encerrar-atendimento')
  }

  RefreshNoAnswer(e, cdrid, queueid, infousers) {
    this.props.PropsRefreshNoAnswer(cdrid, queueid, infousers);
    document.getElementById("simulation_click").click();
  }

  renderPopover = (
    e,
    numberqueue,
    contactname,
    cdrid,
    queueid,
    queue,
    infousers
  ) => (
    <div className="context-menu" id="info-fila">
      <ul className="context-menu__list">
        <li className="context-menu__item">
          <a
            onClick={(event) =>
              this.ShowModals(
                e,
                numberqueue,
                contactname,
                "modal__anotacoes",
                cdrid,
                queueid,
                queue,
                infousers
              )
            }
            className="context-menu__link"
          >
            Anotações
          </a>
        </li>
        <li className="context-menu__item">
          <a
            onClick={(event) =>
              this.ShowModals(
                e,
                numberqueue,
                contactname,
                "modal__arquivos-compartilhados",
                cdrid,
                queueid,
                queue,
                infousers
              )
            }
            className="context-menu__link"
          >
            Arquivos compartilhados
          </a>
        </li>
        <li className="context-menu__item">
          <a
            onClick={(event) =>
              this.ShowModals(
                e,
                numberqueue,
                contactname,
                "modal__mensagens-favoritas",
                cdrid,
                queueid,
                queue,
                infousers
              )
            }
            className="context-menu__link"
          >
            Mensagens favoritas
          </a>
        </li>
        <li className="context-menu__item">
          <a className="context-menu__link">Mapa</a>
        </li>
        <li className="context-menu__item">
          <a
            onClick={(event) =>
              this.ShowModals(
                e,
                numberqueue,
                contactname,
                "modal__historico-atendimento-queue",
                cdrid,
                queueid,
                queue,
                infousers
              )
            }
            className="context-menu__link"
          >
            Interações
          </a>
        </li>
        {(() => {
          if (infousers.supervisor === true && queue.status != "1") {
            return (
              <>
                <li className="context-menu__item">
                  <a
                    className="context-menu__link"
                    onClick={(event) =>
                      this.ShowModals(
                        e,
                        numberqueue,
                        contactname,
                        "modal__excluir",
                        cdrid,
                        queueid,
                        queue,
                        infousers
                      )
                    }
                  >
                    Excluir chamada
                  </a>
                </li>
              </>
            );
          }
        })()}
        {(() => {
          if (infousers.supervisor === true && queue.status != "0") {
            return (
              <>
                {" "}
                <li className="context-menu__item">
                  <a
                    className="context-menu__link"
                    onClick={(event) =>
                      this.RefreshNoAnswer(e, cdrid, queueid, infousers)
                    }
                  >
                    Atualizar para não atendida
                  </a>
                </li>
              </>
            );
          }
        })()}
      </ul>
    </div>
  );

  ShowCriticitys(e) {
    e.preventDefault();
    this.setState({ buttonShowCriticits: !this.state.buttonShowCriticits });
  }

  SelectCriticitys(e, desccriticidade, idcriticidade, tipocriticidade) {
    this.setState({
      critSelec: desccriticidade,
      iconCrit: tipocriticidade,
      idCrit: idcriticidade,
    });
    this.setState({ buttonShowCriticits: !this.state.buttonShowCriticits });
  }

  SelectCriticitys2(e, desccriticidade, idcriticidade, tipocriticidade) {
    this.setState({ SelecCritic: desccriticidade, idCrit2: idcriticidade });
    this.setState({ buttonShowCriticits: !this.state.buttonShowCriticits });
  }

  ShowModals(
    e,
    numberqueue,
    contactname,
    modal,
    cdrid,
    queueid,
    queue,
    infousers
  ) {
    this.ShowNameCli(numberqueue, contactname);
    // eslint-disable-next-line default-case
    switch (modal) {
      case "modal__anotacoes":
        MicroModal.show("modal__anotacoes");
        break;
      case "modal__arquivos-compartilhados":
        MicroModal.show("modal__arquivos-compartilhados");
        break;
      case "modal__mensagens-favoritas":
        MicroModal.show("modal__mensagens-favoritas");
        break;
      case "modal__historico-atendimento-queue":
        this.props.ClearHistory();
        let histstart = this.datahistoryinitqueue.value;
        let histend = this.datahistoryfimqueue.value;
        if (queue.status === "1") {
          this.props.CarregamentoInteractions(cdrid, infousers.idgroup);
        } else {
          this.props.CarregamentoCDR(queueid, infousers.idgroup);
        }
        MicroModal.show("modal__historico-atendimento-queue");
        this.setState({
          clientpdf: numberqueue,
          datapdfend: histend,
          datapdfinit: histend,
          cliente: contactname,
        });
        break;
      case "modal__excluir":
        MicroModal.show("modal__excluir");
        this.setState({
          deletequeueid: cdrid,
          deletecdrid: queueid,
          mediaid: queue.mediaid,
        });
        break;
    }
  }

  buttonSearchMarkstar(e) {
    e.preventDefault();
    var erro = 0;
    let datainit = this.dataInitMarkqueue.value;
    let datafim = this.dataFimMarkqueue.value;

    var comparation = Moment(datainit).isBefore(datafim);

    if (datainit == "") var erro = 1;

    if (datafim == "") var erro = 1;

    if (comparation === false) {
      var erro = 1;
      if (datainit === datafim) {
        var erro = 0;
      }
    }

    if (erro === 0) {
      this.props.DetailsMarkstarida(datainit, datafim, this.state.numberqueue);
    }
  }

  SearchInHistory(e) {
    e.preventDefault();
    this.setState({ showHistory: !this.state.showHistory });
  }

  checkExpandLearnQueue(e, idanot) {
    var checkClick =
      this.state.expandLearn.indexOf(idanot) != -1 ? true : false;

    if (!checkClick) {
      this.setState({
        expandLearn: this.state.expandLearn.concat([idanot]),
      });
    } else {
      this.setState({
        expandLearn: this.state.expandLearn.filter(function (val) {
          return val != idanot;
        }),
      });
    }
  }

  showExpandVisual(e, idarq) {
    var click =
      this.state.optionsActionsFile.indexOf(idarq) != -1 ? true : false;

    if (!click) {
      this.setState({
        optionsActionsFile: this.state.optionsActionsFile.concat([idarq]),
      });
    } else {
      this.setState({
        optionsActionsFile: this.state.optionsActionsFile.filter(function (
          val
        ) {
          return val != idarq;
        }),
      });
    }
  }

  ShowNameCli(numberqueue, contactname) {
    this.setState({ numberqueue: numberqueue });
    if (contactname) {
      var mensagem_tratada = createJSON(contactname);
      this.setState({ nameCli: mensagem_tratada });
    } else {
      this.setState({ nameCli: numberqueue });
    }
  }

  ShowChoiceFormat(e) {
    e.preventDefault();
    this.setState({ buttonShowFormatsFile: !this.state.buttonShowFormatsFile });
  }

  choiceFormat(event, formats, name) {
    this.mimetypeids.value = formats;
    this.setState({
      buttonShowFormatsFile: !this.state.buttonShowFormatsFile,
      defaultValueFormat: name,
    });
  }

  choiceMidia(event, midias, name) {
    this.midias.value = midias;
    this.setState({
      buttonShowMidias: !this.state.buttonShowMidias,
      defaultValueMidias: name,
    });
  }

  ShowChoiceMidias(e) {
    e.preventDefault();
    this.setState({ buttonShowMidias: !this.state.buttonShowMidias });
  }

  DonwloadFile(e, url, name) {
    e.preventDefault();
    this.props.DonwloadFileIn(url, name);
  }

  handleScroll = (e) => {
    let element = e.target;
    let elmnt = document.getElementsByClassName("time");
    // for (var i = 0; i < elmnt.length; i++) {
    // }
    // let y = elmnt.scrollTop;

    // if (element.scrollHeight - element.scrollTop === element.clientHeight) {
    //   // do something at end of scroll
    // }
  };

  VerifierImage(e, urlimage, modal) {
    this.setState({ isOpen: true, urlimage: urlimage });
    if (modal === "history") {
      MicroModal.close("modal__historico-atendimento-queue");
    }
    if (modal === "dmark") {
      MicroModal.close("modal__mensagens-favoritas");
    }
  }

  CloseImage(e, modal) {
    this.setState({ isOpen: false, urlimage: "" });
    if (modal === "history") {
      MicroModal.show("modal__historico-atendimento-queue");
    }
    if (modal === "dmark") {
      MicroModal.show("modal__mensagens-favoritas");
    }
  }

  ScrollView = (e) => {
    let element = e.target;
    let valueScroll = element.scrollTop + element.clientHeight;
    if (element.scrollHeight === valueScroll) {
      this.setState({ scrollEnd: this.state.scrollEnd + 4 });
    }
  };

  render() {
    const {
      listCallQueue,
      InfoUsers,
      PermissionRouter,
      CallBack,
      StatusAgent,
      OutBandService,
      DisplayNextAtd,
      History,
      DetailsAnotations,
      CriticidadesAnotacoes,
      IPCurrent,
      DetailsMarkstar,
      DetailsFileShared,
      AtdSimult,
      Filters,
    } = this.props;
    const { searchText } = this.state;
    const searchWords = searchText.split(/\s/).filter((word) => word);

    this.timedefaultinitqueue = Moment().format("YYYY-MM-DDT00:00");
    this.timedefaultfimqueue = Moment().format("YYYY-MM-DDT23:59");
    this.datatimeinitqueue = Moment().format("YYYY-MM-DD");
    this.datatimefimqueue = Moment().format("YYYY-MM-DD");
    this.timearqinitqueue = Moment().format("YYYY-MM-DD");
    this.timearqfimqueue = Moment().format("YYYY-MM-DD");
    this.datainitqueue = Moment().format("YYYY-MM-DD");
    this.datafimqueue = Moment().format("YYYY-MM-DD");
    var dia = "";
    var mes = "";
    var ano = "";
    var auxdia = "";

    if (DisplayNextAtd.length != 0) {
      if (DisplayNextAtd.displaynextatd === true) {
        this.state.visible = " active";
      } else if (
        DisplayNextAtd.displaynextatd === false ||
        DisplayNextAtd.displaynextatd === "ocultar"
      ) {
        this.state.visible = " w-40";
      } else {
        this.state.visible = " w-40";
      }
    }

    if (listCallQueue.length != 0) {
      this.state.callqueue = listCallQueue;

      if (Filters.length != 0) {
        let filtroArr = Filters.array_fila;
        this.state.callqueue = this.state.callqueue.filter((queue) =>
          filtroArr.includes(queue.status)
        );
      }
      if (this.state.typemedia != "") {
        this.state.callqueue = this.state.callqueue.filter((queue) =>
          this.state.typemedia.includes(queue.mediaid)
        );
      }
    } else {
      this.state.callqueue = [];
    }

    const list = this.state.callqueue || [];

    this.state.callqueue = _.filter(list, (queue) => {
      let arrayQueue = [
        queue.caller,
        queue.called,
        queue.to_char,
        queue.recv_count,
        queue.contactname,
        queue.username,
      ];
      return !_.isEmpty(this.state.filterQueue)
        ? arrayQueue
            .toString()
            .toLowerCase()
            .indexOf(this.state.filterQueue.toString().toLowerCase()) > -1
        : true;
    });

    if (CriticidadesAnotacoes.length != 0) {
      this.state.DescAnotacoes = CriticidadesAnotacoes.criticalitys;
      if (this.state.idCrit2 === 0) {
        this.state.iconeCriticidade =
          this.state.DescAnotacoes[0].class_criticality;
        this.state.SelecCritic = this.state.DescAnotacoes[0].description;
        this.state.idCrit2 = this.state.DescAnotacoes[0].id;
      }
    }

    if (listCallQueue.length != 0) {
      this.state.callqueue.reverse(function (obj1, obj2) {
        return obj1.to_char > obj2.to_char
          ? 1
          : obj2.to_char > obj1.to_char
          ? -1
          : 0;
      });
    } else {
      this.state.callqueue = [];
    }

    if (DetailsAnotations.length != 0) {
      this.state.detailsAnotations = DetailsAnotations.detailsanotations;
      this.state.totalAnotations = this.state.detailsAnotations.length;
    } else {
      this.state.detailsAnotations = [];
      this.state.totalAnotations = 0;
    }

    if (DetailsMarkstar.length != 0) {
      this.state.detailsMarkstar = DetailsMarkstar.detailsmarkstars;
      this.state.totalMarkstar = this.state.detailsMarkstar.length;
    } else {
      this.state.detailsMarkstar = [];
      this.state.totalMarkstar = 0;
    }

    if (DetailsFileShared.length != 0) {
      this.state.detailsFileShared = DetailsFileShared.detailsfileshared;
      this.state.totalFiles = this.state.detailsFileShared.length;
    } else {
      this.state.detailsFileShared = [];
      this.state.totalFiles = 0;
    }

    if (History.length) {
      this.state.history = History;
      let testarultimo = 0;
      var total = this.state.history[0];
      this.state.totalhistory = total.interacoes;
    } else {
      this.state.history = [];
    }

    if (IPCurrent.length !== 0) {
      this.state.midias = IPCurrent.midias;
    }

    if (InfoUsers.user_midias)
      this.state.callqueue = this.state.callqueue.filter((queue) =>
        InfoUsers.user_midias.includes(queue.mediaid)
      );

    if (listCallQueue.length != 0) {
      if (this.state.typemedia != "") {
        this.state.callqueue = this.state.callqueue.filter((queue) =>
          this.state.typemedia.includes(queue.mediaid)
        );
      }
    }

    this.state.callqueue = this.state.callqueue.slice(0, this.state.scrollEnd);

    //if(checkStatusAgente!==StatusAgent.status ){
    if (listCallQueue.length != 0 && parseInt(InfoUsers.tmcallback) > 0) {
      if (StatusAgent.status === "Pausado") {
        clearInterval(statusIntervalCBack);
        checkCallBack = false;
      } else if (StatusAgent.status === "Livre") {
        if (!checkCallBack) {
          this.state.callqueue.map((queue) => {
            if (
              parseInt(queue.callback_count) <
                parseInt(InfoUsers.qtdecallback) &&
              parseInt(queue.status) === 0 &&
              checkCallBack === false
            ) {
              clearInterval(statusIntervalCBack);
              checkCallBack = true;
              checkCallBackAuto(
                queue.queueid,
                InfoUsers.tmcallback,
                InfoUsers.qtdecallback,
                queue
              );
            }
          });
        }
      } else if (
        StatusAgent.status === "Atendimento" ||
        StatusAgent.status === "Ligação" ||
        StatusAgent.status === "Discando" ||
        StatusAgent.status === "Chamando" ||
        StatusAgent.status === "Aftercallwork"
      ) {
        clearInterval(statusIntervalCBack);
        checkCallBack = false;
      }
    }
    //}

    return (
      <div
        id="column1"
        className={
          "chat-page small-column small-column--margin-right" +
          this.state.visible
        }
      >
        <div
          className="block full-height no-margin-bottom small-column"
          id="proximos-atendimentos"
        >
          <div className="column-model__header">
            <div className="column-model__header__title">
              <button
                type="submit"
                onClick={(event) => this.ShowVisible(event)}
                className="column-model__header__title__btn tippy-default"
                data-tippy-content="Ocultar"
              >
                <i className="material-icons">arrow_back</i>
              </button>
              <div className="text">Próximos atendimentos</div>
            </div>
            <div className="column-model__header__select">
              <div
                className={
                  this.state.buttonFilterQueue
                    ? "select with-icons with-footer-action active"
                    : "select with-icons with-footer-action"
                }
              >
                <button
                  className="select__btn"
                  type="button"
                  onClick={(event) => this.DisplayFilterQueue(event)}
                >
                  Filtros
                  <i className="select__icon material-icons">
                    keyboard_arrow_right
                  </i>
                </button>
                <div className="options">
                  <ul>
                    <li style={{ marginBottom: "7px" }}>
                      <input
                        type="checkbox"
                        name="inputcallback"
                        id="inputcallback"
                        checked={
                          Filters.fila_checkbox_callback === "true" ||
                          Filters.fila_checkbox_callback === true
                            ? true
                            : false
                        }
                        onChange={(event) => this.getFilterQueue(event, "0")}
                      />
                      <label htmlFor="inputcallback">CallBack</label>
                    </li>
                    <li style={{ marginBottom: "7px" }}>
                      <input
                        type="checkbox"
                        name="inputqueue"
                        id="inputqueue"
                        checked={
                          Filters.fila_checkbox_espera === "true" ||
                          Filters.fila_checkbox_espera === true
                            ? true
                            : false
                        }
                        onChange={(event) => this.getFilterQueue(event, "1")}
                      />
                      <label htmlFor="inputqueue">Em fila de espera</label>
                    </li>
                    <li style={{ marginBottom: "7px" }}>
                      <input
                        type="checkbox"
                        name="inputtrat"
                        id="inputtrat"
                        checked={
                          Filters.fila_checkbox_em_tratamento === "true" ||
                          Filters.fila_checkbox_em_tratamento === true
                            ? true
                            : false
                        }
                        onChange={(event) => this.getFilterQueue(event, "2")}
                      />
                      <label htmlFor="inputtrat">Em Tratamento</label>
                    </li>
                    <li style={{ marginBottom: "7px" }}>
                      <input
                        type="checkbox"
                        name="inputretorno"
                        id="inputretorno"
                        checked={
                          Filters.fila_checkbox_retorno === "true" ||
                          Filters.fila_checkbox_retorno === true
                            ? true
                            : false
                        }
                        onChange={(event) => this.getFilterQueue(event, "5")}
                      />
                      <label htmlFor="inputretorno">Retornando</label>
                    </li>
                    <li>
                      <hr />
                    </li>
                    {this.state.midias.map((midia) => (
                      <li style={{ marginBottom: "4px" }} key={keycount++}>
                        <input
                          type="checkbox"
                          name={"input" + midia.describer}
                          id={"input" + midia.describer}
                          defaultChecked={
                            this.state.typemedia.findIndex(function (val) {
                              return val === midia.id;
                            }) !== -1
                              ? true
                              : false
                          }
                          onChange={(event) =>
                            this.getFilterMedia(event, midia.id)
                          }
                        />{" "}
                        <label htmlFor={"input" + midia.describer}>
                          {midia.describer}
                        </label>
                      </li>
                    ))}
                  </ul>

                  <a
                    className="btn btn-primary"
                    style={{ position: "absolute" }}
                    id="apply-filters"
                    onClick={(event) => this.DisplayFilterQueue(event)}
                  >
                    Fechar
                  </a>
                </div>
              </div>
            </div>

            <div className="full-search">
              <input
                type="text"
                name="client-search"
                id="client-search"
                onChange={(event) => this.changeQueue(event)}
                placeholder="Pesquise aqui..."
              />
              <button type="submit" className="full-search__btn">
                <i className="material-icons">search</i>
              </button>
            </div>
          </div>
          <div className="top-bar" onClick={this.DisplayDetails.bind(this)}>
            <a
              href="{#}"
              className="btn btn-inline"
              data-action={this.state.expandcollapse}
              id="expand-all-user-info"
            >
              <i className="material-icons">{this.state.unfold}</i>
              {this.state.RetractExpand}
            </a>
          </div>
          <div
            className="block-content overflow flex-column list"
            onScroll={this.ScrollView}
          >
            {this.state.callqueue.map((queue) => {
              const queueItemProps = {
                queue,
                IPCurrent,
                InfoUsers,
                StatusAgent,
                AtdSimult,
                OutBandService,
                PermissionRouter,
                expandQueue: this.state.expandQueue,
                buttonDetails: this.state.buttonDetails,
              };
              return (
                <QueueItem
                  key={queue.queueid}
                  checkExpandQueue={this.checkExpandQueue}
                  renderPopover={this.renderPopover}
                  SolicitarChamada={this.props.SolicitarChamada}
                  SolicitarChamadaAtiva={this.SolicitarChamadaAtiva}
                  {...queueItemProps}
                />
              );
            })}
          </div>
        </div>

        {/* Modal De Anotacoes */}

        <div
          className="modal micromodal-slide"
          id="modal__anotacoes"
          aria-hidden="true"
          role="dialog"
        >
          <div className="modal__overlay" tabIndex="-1">
            <div
              className="modal__container"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal__anotacoes__title"
            >
              <header className="modal__header">
                <h2 className="modal__title" id="modal__anotacoes__title">
                  Anotações
                </h2>
                <button
                  className="modal__close"
                  aria-label="Close modal"
                  data-micromodal-close
                ></button>
              </header>
              <main className="modal__content" id="modal__anotacoes__content">
                <div className="anotc__info">
                  <p className="anotc__name  is-poppins">
                    {createJSON(this.state.nameCli)}
                  </p>
                  <i className="material-icons anotc__icon">note</i>{" "}
                  <span className="anotc__info-text">
                    Total de{" "}
                    <span className="anotc__counter">
                      {this.state.totalAnotations}
                    </span>{" "}
                    anotações
                  </span>
                </div>
                <div className="anotc__wrapper">
                  <div className="anotc__mp">
                    <div className="anotc__mp-ctrL">
                      <div className="anotc__mp-date">
                        <p className="anotc__mp-date-text">
                          Deseja buscar as anotação de qual período?
                        </p>
                        <div className="anotc__mp-date-wrapper">
                          <span className="anotc__mp-date-span">De:</span>
                          <input
                            type="date"
                            className="anotc__mp-date-start"
                            defaultValue={this.datatimeinitqueue}
                            ref={(input) => (this.dataInitqueue = input)}
                          />
                          <span className="anotc__mp-date-span">Até:</span>
                          <input
                            type="date"
                            className="anotc__mp-date-end"
                            defaultValue={this.datatimefimqueue}
                            ref={(input) => (this.dataFimqueue = input)}
                          />
                        </div>
                      </div>
                      <div className="anotc__mp-critic">
                        <p className="anotc__mp-critic-text">
                          E com qual nível de criticidade?
                        </p>
                        <div className="anotc__mp-critic-wrapper">
                          <button
                            className="anotc__mp-critic-btn"
                            onClick={this.ShowCriticitys.bind(this)}
                          >
                            {this.state.critSelec}
                            <i className="anotc__mp-critic-icon material-icons">
                              keyboard_arrow_down
                            </i>
                          </button>
                          <div
                            className={
                              this.state.buttonShowCriticits
                                ? "anotc__mp-critic-options active"
                                : "anotc__mp-critic-options"
                            }
                          >
                            <ul className="anotc__mp-critic-list">
                              <li
                                className="anotc__mp-critic-item"
                                onClick={this.SelectCriticitys.bind(
                                  this,
                                  "",
                                  "Todos",
                                  ""
                                )}
                              >
                                <span className="anotc__mp-critic-dot">•</span>
                                Todos
                              </li>
                              {this.state.DescAnotacoes.map((desc) => (
                                <li
                                  key={desc.id}
                                  className="anotc__mp-critic-item"
                                  onClick={this.SelectCriticitys.bind(
                                    this,
                                    desc.class_criticality,
                                    desc.description,
                                    desc.id
                                  )}
                                >
                                  <span
                                    className={
                                      "anotc__mp-critic-dot " +
                                      desc.class_criticality
                                    }
                                  >
                                    •
                                  </span>
                                  {desc.description}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                      <button
                        className="anotc__mp-btn"
                        onClick={(event) => this.buttonSearchAnotation(event)}
                      >
                        Filtrar
                      </button>
                    </div>

                    <div className="anotc__mp-result">
                      <div className="anotc__mp-search">
                        <span className="material-icons anotc__mp-search-icon">
                          expand_less
                        </span>
                        <span className="material-icons anotc__mp-search-icon">
                          expand_more
                        </span>
                        <input
                          type="text"
                          className="anotc__mp-search-input"
                          placeholder="Pesquisar..."
                        />
                        <button className="anotc__mp-search-btn">
                          Concluir
                        </button>
                      </div>

                      <ul className="anotc__mp-result-list">
                        {this.state.detailsAnotations.map((details) => (
                          <li
                            key={details.id}
                            className="anotc__mp-result-item"
                          >
                            <button className="anotc__mp-result-avatar">
                              <img src="build/images/cliente.svg" alt="" />
                            </button>
                            <a
                              className="anotc__mp-result-btn"
                              onClick={(event) =>
                                this.checkExpandLearnQueue(event, details.id)
                              }
                            >
                              <span className="anotc__mp-result-span material-icons">
                                {this.state.buttonLearnMore ||
                                this.state.expandLearn.indexOf(details.id) != -1
                                  ? "remove_circle_outline"
                                  : "add_circle_outline"}
                              </span>
                              <span
                                className={
                                  this.state.buttonLearnMore ||
                                  this.state.expandLearn.indexOf(details.id) !=
                                    -1
                                    ? "hack"
                                    : "hack active"
                                }
                              >
                                {" "}
                                Leia mais
                              </span>
                              <span
                                className={
                                  this.state.buttonLearnMore ||
                                  this.state.expandLearn.indexOf(details.id) !=
                                    -1
                                    ? "hack active"
                                    : "hack"
                                }
                              >
                                {" "}
                                Leia menos
                              </span>
                            </a>
                            <div className="anotc__mp-result-item-top">
                              <div className="anotc__mp-result-item-info">
                                <p className="anotc__mp-result-item-name">
                                  {createJSON(this.state.nameCli)}
                                </p>
                                <p className="anotc__mp-result-item-title">
                                  {details.usuario_anotacao}
                                </p>
                              </div>
                              <div className="anotc__mp-result-item-critic">
                                <span
                                  className={
                                    "anotc__mp-result-item-level " +
                                    details.class_criticality
                                  }
                                >
                                  {details.desc_criticidade}
                                </span>
                                <span className="anotc__mp-result-item-fulltime">
                                  {details.data_anotacao +
                                    " - " +
                                    details.hora_anotacao}
                                </span>
                              </div>
                            </div>
                            <div
                              className={
                                this.state.buttonLearnMore ||
                                this.state.expandLearn.indexOf(details.id) != -1
                                  ? "anotc__mp-result-item-content auto"
                                  : "anotc__mp-result-item-content"
                              }
                            >
                              {details.desc_anotacao}
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="flab">
                  <a className="flab__button">
                    <div className="material-icons">add</div>
                  </a>
                  <div className="flab__related">
                    {/* onclick="toggleModal('modal__anotacoes-adicionar')"  */}
                    <a
                      className="btn--add-anotc flab__related__button tippy-default"
                      data-tippy-content="Adicionar uma anotação"
                      data-tippy-theme="light"
                      data-tippy-placement="left"
                    >
                      <div className="material-icons">note_add</div>
                    </a>
                    <a
                      className="btn--search-anotc flab__related__button tippy-default"
                      data-tippy-content="Adicionar em uma anotação"
                      data-tippy-theme="light"
                      data-tippy-placement="left"
                    >
                      <div className="material-icons">search</div>
                    </a>
                  </div>
                  <div className="flab__overlay"></div>
                </div>
              </main>
            </div>
          </div>
        </div>

        {/* Fim do Modal de Anotações */}

        {/* Modal de Mensagens Favoritas */}
        <div
          className="modal micromodal-slide"
          id="modal__mensagens-favoritas"
          aria-hidden="true"
          role="dialog"
        >
          <div className="modal__overlay" tabIndex="-1">
            <div
              className="modal__container"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal__mensagens-favoritas__title"
            >
              <header className="modal__header">
                <h2
                  className="modal__title"
                  id="modal__mensagens-favoritas__title"
                >
                  Mensagens favoritas
                </h2>
                <button
                  className="modal__close"
                  aria-label="Close modal"
                  data-micromodal-close
                ></button>
              </header>
              <main
                className="modal__content"
                id="modal__mensagens-favoritas__content"
              >
                <div className="msg-fav__info">
                  <p className="msg-fav__name  is-poppins">
                    {createJSON(this.state.nameCli)}
                  </p>
                  <i className="material-icons msg-fav__icon">note</i>{" "}
                  <span className="msg-fav__info-text">
                    Total de{" "}
                    <span className="msg-fav__counter">
                      {this.state.totalMarkstar}
                    </span>{" "}
                    mensagens
                  </span>
                </div>
                <div className="msg-fav__wrapper">
                  <div className="msg-fav__mp">
                    <div className="msg-fav__mp-ctrL">
                      <p className="msg-fav__mp-text">Período:</p>
                      <div className="msg-fav__mp-date">
                        <div className="msg-fav__mp-date-wrapper">
                          <span className="msg-fav__mp-date-span">De:</span>
                          <input
                            type="date"
                            defaultValue={this.datatimeinitqueue}
                            className="msg-fav__mp-date-start"
                            ref={(input) => (this.dataInitMarkqueue = input)}
                          />
                          <span className="msg-fav__mp-date-span">Até:</span>
                          <input
                            type="date"
                            className="msg-fav__mp-date-end"
                            defaultValue={this.datatimefimqueue}
                            ref={(input) => (this.dataFimMarkqueue = input)}
                          />
                        </div>
                      </div>
                      <button
                        className="msg-fav__mp-btn"
                        onClick={(event) => this.buttonSearchMarkstar(event)}
                      >
                        Filtrar
                      </button>
                    </div>
                    {/* <!-- END CTRL --> */}
                    <div className="msg-fav__mp-result">
                      <ul className="msg-fav__mp-list">
                        {this.state.detailsMarkstar.map((dmark) =>
                          (() => {
                            var positmessage1 = "";
                            var positmessage2 = "";
                            if (dmark.is_from_agent === true) {
                              positmessage1 = " right";
                            }
                            if (dmark.mimetypeid == "1") {
                              return (
                                <li
                                  key={dmark.id}
                                  className={"msg-fav__mp-item" + positmessage1}
                                >
                                  <p className="msg-fav__mp-time">
                                    <span className="msg-fav__mp-day">
                                      {dmark.data_markstar}
                                    </span>{" "}
                                    -{" "}
                                    <span className="msg-fav__mp-hour">
                                      {dmark.hora_markstar}
                                    </span>
                                  </p>
                                  <div className="msg-fav__mp-bubble">
                                    {dmark.mensagem}
                                    <span className="msg-fav__mp-star material-icons">
                                      star
                                    </span>
                                  </div>
                                </li>
                              );
                            } else {
                              if (dmark.mimetypeid == "2") {
                                if (isJson(dmark.mensagem) === true) {
                                  let json = JSON.parse(dmark.mensagem);
                                  let options = json.options;
                                  let i = 1;
                                  var opcoes = [];
                                  for (i in options) {
                                    opcoes.push(i + " - " + options[i][1]);
                                  }
                                  return (
                                    <li
                                      className={
                                        "msg-fav__mp-item" + positmessage1
                                      }
                                    >
                                      {dmark.mensagem}
                                    </li>
                                  );
                                } else {
                                  return (
                                    <li
                                      className={
                                        "msg-fav__mp-item" + positmessage1
                                      }
                                    >
                                      {dmark.mensagem}
                                    </li>
                                  );
                                }
                              } else if (
                                dmark.mimetypeid == "3" ||
                                dmark.mimetypeid == "5" ||
                                dmark.mimetypeid > "6"
                              ) {
                                let separador = dmark.mensagem.split(".");
                                switch (separador[1]) {
                                  case "jpeg":
                                  case "png":
                                  case "jpg":
                                    return (
                                      <li
                                        className={
                                          "msg-fav__mp-item" + positmessage1
                                        }
                                      >
                                        <p className="msg-fav__mp-time">
                                          <span className="msg-fav__mp-day">
                                            {dmark.data_markstar}
                                          </span>{" "}
                                          -{" "}
                                          <span className="msg-fav__mp-hour">
                                            {dmark.hora_markstar}
                                          </span>
                                        </p>
                                        <div className="msg-fav__mp-bubble">
                                          <div className="message left msg-fav__media">
                                            <div className="bubble-media">
                                              <div
                                                className="bubble-media__image"
                                                onClick={(e) =>
                                                  this.VerifierImage(
                                                    e,
                                                    connection_platform.type_connect +
                                                      "://" +
                                                      ipcurrent +
                                                      dmark.mensagem,
                                                    "dmark"
                                                  )
                                                }
                                              >
                                                {this.state.isOpen && (
                                                  <Lightbox
                                                    mainSrc={
                                                      this.state.urlimage
                                                    }
                                                    onCloseRequest={(e) =>
                                                      this.CloseImage(
                                                        e,
                                                        "dmark"
                                                      )
                                                    }
                                                  />
                                                )}
                                                <img
                                                  src={
                                                    connection_platform.type_connect +
                                                    "://" +
                                                    ipcurrent +
                                                    dmark.mensagem
                                                  }
                                                  alt=""
                                                />
                                              </div>
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={JPG}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    Nome do Arquivo
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {dbfileSize(
                                                        dmark.filesize
                                                      )}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {""}
                                                    </span>
                                                  </div>
                                                </span>
                                                {(() => {
                                                  if (
                                                    InfoUsers.permdownload ===
                                                    true
                                                  ) {
                                                    return (
                                                      <div className="bubble-media__download">
                                                        <a
                                                          href={
                                                            connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            dmark.mensagem
                                                          }
                                                          target="_blank"
                                                          download
                                                          className="bubble-media__btnDownload"
                                                        >
                                                          <i className="material-icons">
                                                            get_app
                                                          </i>
                                                        </a>
                                                      </div>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            </div>
                                          </div>
                                          <span className="msg-fav__mp-star material-icons">
                                            star
                                          </span>
                                        </div>
                                      </li>
                                    );
                                    break;
                                  case "pdf":
                                    return (
                                      <li
                                        className={
                                          "msg-fav__mp-item" + positmessage1
                                        }
                                      >
                                        <p className="msg-fav__mp-time">
                                          <span className="msg-fav__mp-day">
                                            {dmark.data_markstar}
                                          </span>{" "}
                                          -{" "}
                                          <span className="msg-fav__mp-hour">
                                            {dmark.hora_markstar}
                                          </span>
                                        </p>
                                        <div className="msg-fav__mp-bubble">
                                          <div className="message left msg-fav__media">
                                            <div className="bubble-media">
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={PDF}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    Nome do Arquivo
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {dbfileSize(
                                                        dmark.filesize
                                                      )}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {""}
                                                    </span>
                                                  </div>
                                                </span>

                                                {(() => {
                                                  if (
                                                    InfoUsers.permdownload ===
                                                    true
                                                  ) {
                                                    return (
                                                      <div className="bubble-media__download">
                                                        <a
                                                          href={
                                                            connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            dmark.mensagem
                                                          }
                                                          target="_blank"
                                                          download
                                                          className="bubble-media__btnDownload"
                                                        >
                                                          <i className="material-icons">
                                                            get_app
                                                          </i>
                                                        </a>
                                                      </div>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            </div>
                                          </div>
                                          <span className="msg-fav__mp-star material-icons">
                                            star
                                          </span>
                                        </div>
                                      </li>
                                    );
                                    break;
                                  case "xls":
                                  case "xlsx":
                                  case "xlsm":
                                  case "doc":
                                  case "docx":
                                  case "ppt":
                                  case "pptx":
                                    return (
                                      <li
                                        className={
                                          "msg-fav__mp-item" + positmessage1
                                        }
                                      >
                                        <p className="msg-fav__mp-time">
                                          <span className="msg-fav__mp-day">
                                            {dmark.data_markstar}
                                          </span>{" "}
                                          -{" "}
                                          <span className="msg-fav__mp-hour">
                                            {dmark.hora_markstar}
                                          </span>
                                        </p>
                                        <div className="msg-fav__mp-bubble">
                                          <div className="message left msg-fav__media">
                                            <div className="bubble-media">
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={XLS}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    Nome do Arquivo
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {dbfileSize(
                                                        dmark.filesize
                                                      )}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {""}
                                                    </span>
                                                  </div>
                                                </span>

                                                {(() => {
                                                  if (
                                                    InfoUsers.permdownload ===
                                                    true
                                                  ) {
                                                    return (
                                                      <div className="bubble-media__download">
                                                        <a
                                                          href={
                                                            connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            dmark.mensagem
                                                          }
                                                          target="_blank"
                                                          download
                                                          className="bubble-media__btnDownload"
                                                        >
                                                          <i className="material-icons">
                                                            get_app
                                                          </i>
                                                        </a>
                                                      </div>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            </div>
                                          </div>
                                          <span className="msg-fav__mp-star material-icons">
                                            star
                                          </span>
                                        </div>
                                      </li>
                                    );
                                    break;
                                  case "wav":
                                  case "mp3":
                                  case "ogg":
                                  case "mpeg":
                                    return (
                                      <li
                                        className={
                                          "msg-fav__mp-item" + positmessage1
                                        }
                                      >
                                        <p className="msg-fav__mp-time">
                                          <span className="msg-fav__mp-day">
                                            {dmark.data_markstar}
                                          </span>{" "}
                                          -{" "}
                                          <span className="msg-fav__mp-hour">
                                            {dmark.hora_markstar}
                                          </span>
                                        </p>
                                        <div className="msg-fav__mp-bubble">
                                          <div className="message left msg-fav__media">
                                            <div className="bubble-media">
                                              <div className="bubble-media__playerBar">
                                                <audio controls>
                                                  <source
                                                    src={
                                                      connection_platform.type_connect +
                                                      "://" +
                                                      ipcurrent +
                                                      dmark.mensagem
                                                    }
                                                    type="audio/ogg"
                                                  />
                                                  <source
                                                    src={
                                                      connection_platform.type_connect +
                                                      "://" +
                                                      ipcurrent +
                                                      dmark.mensagem
                                                    }
                                                    type="audio/mpeg"
                                                  />
                                                  Your browser.
                                                </audio>
                                              </div>
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={MP3}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    Nome do Arquivo
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {dbfileSize(
                                                        dmark.filesize
                                                      )}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {""}
                                                    </span>
                                                  </div>
                                                </span>

                                                {(() => {
                                                  if (
                                                    InfoUsers.permdownload ===
                                                    true
                                                  ) {
                                                    return (
                                                      <div className="bubble-media__download">
                                                        <a
                                                          href={
                                                            connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            dmark.mensagem
                                                          }
                                                          target="_blank"
                                                          download
                                                          className="bubble-media__btnDownload"
                                                        >
                                                          <i className="material-icons">
                                                            get_app
                                                          </i>
                                                        </a>
                                                      </div>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            </div>
                                          </div>
                                          <span className="msg-fav__mp-star material-icons">
                                            star
                                          </span>
                                        </div>
                                      </li>
                                    );
                                    break;
                                  case "mp4":
                                    return (
                                      <li
                                        className={
                                          "msg-fav__mp-item" + positmessage1
                                        }
                                      >
                                        <p className="msg-fav__mp-time">
                                          <span className="msg-fav__mp-day">
                                            {dmark.data_markstar}
                                          </span>{" "}
                                          -{" "}
                                          <span className="msg-fav__mp-hour">
                                            {dmark.hora_markstar}
                                          </span>
                                        </p>
                                        <div className="msg-fav__mp-bubble">
                                          <div className="message left msg-fav__media">
                                            <div className="bubble-media">
                                              <div className="bubble-media__video">
                                                <video
                                                  className="bubble-media__video-frame"
                                                  controls
                                                >
                                                  <source
                                                    className="bubble-media__video-file"
                                                    src={
                                                      connection_platform.type_connect +
                                                      "://" +
                                                      ipcurrent +
                                                      dmark.mensagem
                                                    }
                                                    type="video/mp4"
                                                  />
                                                  Seu navegador nao suporta esse
                                                  tipo de arquivo.
                                                </video>
                                              </div>
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={AVI}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    Nome do Arquivo
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {dbfileSize(
                                                        dmark.filesize
                                                      )}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {""}
                                                    </span>
                                                  </div>
                                                </span>

                                                {(() => {
                                                  if (
                                                    InfoUsers.permdownload ===
                                                    true
                                                  ) {
                                                    return (
                                                      <div className="bubble-media__download">
                                                        <a
                                                          href={
                                                            connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            dmark.mensagem
                                                          }
                                                          target="_blank"
                                                          download
                                                          className="bubble-media__btnDownload"
                                                        >
                                                          <i className="material-icons">
                                                            get_app
                                                          </i>
                                                        </a>
                                                      </div>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            </div>
                                          </div>
                                          <span className="msg-fav__mp-star material-icons">
                                            star
                                          </span>
                                        </div>
                                      </li>
                                    );
                                    break;
                                  default:
                                    if (
                                      dmark.messagem.indexOf("https") > -1 &&
                                      dmark.messagem !== ""
                                    ) {
                                      if (
                                        parseInt(dmark.mimetypeid) === 16 ||
                                        parseInt(dmark.mimetypeid) === 41
                                      ) {
                                        return (
                                          <div className="bubble-media">
                                            <div className="bubble-media__video">
                                              <video
                                                className="bubble-media__video-frame"
                                                controls
                                              >
                                                <source
                                                  className="bubble-media__video-file"
                                                  src={dmark.messagem}
                                                  type="video/mp4"
                                                />
                                                Seu navegador nao suporta esse
                                                tipo de arquivo.
                                              </video>
                                            </div>
                                            <div className="bubble-media__mediaInfo">
                                              <span className="bubble-media__fileType">
                                                <img
                                                  className="bubble-media__fileIcon"
                                                  src={AVI}
                                                  alt=""
                                                />
                                              </span>
                                              <span className="bubble-media__fileName">
                                                <p className="bubble-media__text">
                                                  Nome do Arquivo
                                                </p>
                                                <br />
                                                <div className="fileinfo__bar">
                                                  <span className="fileinfo__size">
                                                    {dbfileSize(dmark.filesize)}
                                                  </span>{" "}
                                                  •{" "}
                                                  <span className="fileinfo__type">
                                                    {""}
                                                  </span>
                                                </div>
                                              </span>
                                              {(() => {
                                                if (
                                                  InfoUsers.permdownload ===
                                                  true
                                                ) {
                                                  return (
                                                    <div className="bubble-media__download">
                                                      <a
                                                        href={dmark.messagem}
                                                        target="_blank"
                                                        download
                                                        className="bubble-media__btnDownload"
                                                      >
                                                        <i className="material-icons">
                                                          get_app
                                                        </i>
                                                      </a>
                                                    </div>
                                                  );
                                                }
                                              })()}
                                            </div>
                                          </div>
                                        );
                                      } else if (
                                        parseInt(dmark.mimetypeid) === 1
                                      ) {
                                        var mensagem_tratada = tratarMSG(
                                          dmark.messagem
                                        );
                                        mensagem_tratada =
                                          mensagem_tratada.replace(
                                            /\\n/gi,
                                            "\r\n"
                                          );
                                        return (
                                          <div>
                                            <Highlighter
                                              highlightClassName="YourHighlightClass"
                                              searchWords={searchWords}
                                              autoEscape={true}
                                              textToHighlight={mensagem_tratada}
                                              sanitize={latinize}
                                            />
                                            <span className="text__end-spacing"></span>
                                          </div>
                                        );
                                      } else if (
                                        parseInt(dmark.mimetypeid) === 5 ||
                                        parseInt(dmark.mimetypeid) === 7 ||
                                        parseInt(dmark.mimetypeid) === 8 ||
                                        parseInt(dmark.mimetypeid) === 9 ||
                                        parseInt(dmark.mimetypeid) === 10 ||
                                        parseInt(dmark.mimetypeid) === 11 ||
                                        parseInt(dmark.mimetypeid) === 12 ||
                                        parseInt(dmark.mimetypeid) === 13 ||
                                        parseInt(dmark.mimetypeid) === 14
                                      ) {
                                        return (
                                          <div className="bubble-media">
                                            <div className="bubble-media__mediaInfo">
                                              <span className="bubble-media__fileType"></span>
                                              <span className="bubble-media__fileName">
                                                <p className="bubble-media__text">
                                                  Nome do Arquivo
                                                </p>
                                                <br />
                                                <div className="fileinfo__bar">
                                                  <span className="fileinfo__size">
                                                    {dbfileSize(dmark.filesize)}
                                                  </span>{" "}
                                                  •{" "}
                                                  <span className="fileinfo__type">
                                                    {""}
                                                  </span>
                                                </div>
                                              </span>
                                              {(() => {
                                                if (
                                                  InfoUsers.permdownload ===
                                                  true
                                                ) {
                                                  return (
                                                    <div className="bubble-media__download">
                                                      <a
                                                        href={dmark.messagem}
                                                        target="_blank"
                                                        download
                                                        className="bubble-media__btnDownload"
                                                      >
                                                        <i className="material-icons">
                                                          get_app
                                                        </i>
                                                      </a>
                                                    </div>
                                                  );
                                                }
                                              })()}
                                            </div>
                                          </div>
                                        );
                                      } else if (
                                        parseInt(dmark.mimetypeid) === 4 ||
                                        parseInt(dmark.mimetypeid) === 6 ||
                                        parseInt(dmark.mimetypeid) === 15 ||
                                        parseInt(dmark.mimetypeid) === 17 ||
                                        parseInt(dmark.mimetypeid) === 21 ||
                                        parseInt(dmark.mimetypeid) === 25 ||
                                        parseInt(dmark.mimetypeid) === 26 ||
                                        parseInt(dmark.mimetypeid) === 27 ||
                                        parseInt(dmark.mimetypeid) === 28 ||
                                        parseInt(dmark.mimetypeid) === 40
                                      ) {
                                        return (
                                          <div className="bubble-media">
                                            <div className="bubble-media__playerBar">
                                              <audio controls>
                                                <source
                                                  src={dmark.messagem}
                                                  type="audio/ogg"
                                                />
                                                <source
                                                  src={dmark.messagem}
                                                  type="audio/mpeg"
                                                />
                                                Your browser.
                                              </audio>
                                            </div>
                                            <div className="bubble-media__mediaInfo">
                                              <span className="bubble-media__fileType">
                                                {/* <img className="bubble-media__fileIcon" src={MP3} alt="" /> */}
                                              </span>
                                              <span className="bubble-media__fileName">
                                                <p className="bubble-media__text">
                                                  Nome do Arquivo
                                                </p>
                                                <br />
                                                <div className="fileinfo__bar">
                                                  <span className="fileinfo__size">
                                                    {dbfileSize(dmark.filesize)}
                                                  </span>{" "}
                                                  •{" "}
                                                  <span className="fileinfo__type">
                                                    {""}
                                                  </span>
                                                </div>
                                              </span>
                                              {(() => {
                                                if (
                                                  InfoUsers.permdownload ===
                                                  true
                                                ) {
                                                  return (
                                                    <div className="bubble-media__download">
                                                      <a
                                                        href={dmark.messagem}
                                                        target="_blank"
                                                        download
                                                        className="bubble-media__btnDownload"
                                                      >
                                                        <i className="material-icons">
                                                          get_app
                                                        </i>
                                                      </a>
                                                    </div>
                                                  );
                                                }
                                              })()}
                                            </div>
                                          </div>
                                        );
                                      } else if (
                                        parseInt(dmark.mimetypeid) === 3 ||
                                        parseInt(dmark.mimetypeid) === 18 ||
                                        parseInt(dmark.mimetypeid) === 19 ||
                                        parseInt(dmark.mimetypeid) === 20 ||
                                        parseInt(dmark.mimetypeid) === 22 ||
                                        parseInt(dmark.mimetypeid) === 23 ||
                                        parseInt(dmark.mimetypeid) === 24
                                      ) {
                                        return (
                                          <div className="bubble-media">
                                            <div
                                              className="bubble-media__image"
                                              onClick={(e) =>
                                                this.VerifierImage(
                                                  e,
                                                  dmark.messagem,
                                                  "dmark"
                                                )
                                              }
                                            >
                                              {this.state.isOpen && (
                                                <Lightbox
                                                  mainSrc={this.state.urlimage}
                                                  onCloseRequest={(e) =>
                                                    this.CloseImage(e, "dmark")
                                                  }
                                                />
                                              )}
                                              <img
                                                src={dmark.messagem}
                                                alt=""
                                              />
                                            </div>
                                            <div className="bubble-media__mediaInfo">
                                              <span className="bubble-media__fileType"></span>
                                              <span className="bubble-media__fileName">
                                                <p className="bubble-media__text">
                                                  Nome do Arquivo
                                                </p>
                                                <br />
                                                <div className="fileinfo__bar">
                                                  <span className="fileinfo__size">
                                                    {dbfileSize(dmark.filesize)}
                                                  </span>{" "}
                                                  •{" "}
                                                  <span className="fileinfo__type">
                                                    {""}
                                                  </span>
                                                </div>
                                              </span>
                                              {(() => {
                                                if (
                                                  InfoUsers.permdownload ===
                                                  true
                                                ) {
                                                  return (
                                                    <div className="bubble-media__download">
                                                      <a
                                                        href={dmark.messagem}
                                                        target="_blank"
                                                        download
                                                        className="bubble-media__btnDownload"
                                                      >
                                                        <i className="material-icons">
                                                          get_app
                                                        </i>
                                                      </a>
                                                    </div>
                                                  );
                                                }
                                              })()}
                                            </div>
                                          </div>
                                        );
                                      }
                                    }
                                }
                              }
                            }
                          })()
                        )}
                      </ul>
                    </div>
                    {/* <!-- MP RESULT --> */}
                  </div>
                  {/* <!-- END MP --> */}
                  <div className="msg-fav__null">
                    <img
                      src="build/images/msg-fav__null.svg"
                      alt=""
                      className="msg-fav__null-img"
                    />
                    <h3 className="is-poppins msg-fav__null-title">
                      Voce não possui{" "}
                      <span className="is-poppins is-poppins--bold">
                        mensagens favoritas.
                      </span>
                    </h3>
                    <p className="msg-fav__null-text">
                      Clique no ícone da estrela no canto inferior de cada
                      mensagem para marcá-la como favorita. Assim, você poderá
                      encontrá-la depois aqui.
                    </p>
                  </div>
                </div>
              </main>
            </div>
          </div>
        </div>

        {/* Fim do Modal Mensagens Favoritas */}

        {/* Modal Arquivos Compartilhados */}

        <div
          className="modal micromodal-slide"
          id="modal__arquivos-compartilhados"
          aria-hidden="true"
          role="dialog"
        >
          <div className="modal__overlay" tabIndex="-1">
            <div
              className="modal__container"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal__arquivos-compartilhados__title"
            >
              <header className="modal__header">
                <h2
                  className="modal__title"
                  id="modal__arquivos-compartilhados__title"
                >
                  Arquivos compartilhados
                </h2>
                <button
                  className="modal__close"
                  aria-label="Close modal"
                  data-micromodal-close
                ></button>
              </header>
              <main
                className="modal__content"
                id="modal__arquivos-compartilhados__content"
              >
                <div className="arq-comp__info">
                  <p className="arq-comp__name  is-poppins">
                    {createJSON(this.state.nameCli)}
                  </p>
                  <i className="material-icons arq-comp__icon">
                    insert_drive_file
                  </i>{" "}
                  <span className="arq-comp__info-text">
                    Total de{" "}
                    <span className="arq-comp__counter">
                      {this.state.totalFiles}
                    </span>{" "}
                    arquivo&#x28;s&#x29;
                  </span>
                </div>
                <div className="arq-comp__sub-panel">
                  <p className="arq-comp__text">
                    Use os campos abaixo para filtrar a sua pesquisa
                  </p>
                  <div className="arq-comp__sub-panel__grid">
                    <div className="arq-comp__time-panel">
                      <p className="arq-comp__text">Periodo:</p>
                      <div className="arq-comp__ctrls">
                        <span className="arq-comp__span ml-0">De:</span>
                        <input
                          type="date"
                          defaultValue={this.timearqinitqueue}
                          ref={(input) => (this.timearqinitqueue = input)}
                          className="arq-comp__start"
                        />
                        <span className="arq-comp__span">Até:</span>
                        <input
                          type="date"
                          defaultValue={this.timearqfimqueue}
                          ref={(input) => (this.timearqfimqueue = input)}
                          className="arq-comp__end"
                        />
                      </div>
                    </div>
                    <div className="arq-comp__format-panel">
                      <p className="arq-comp__text">Formato:</p>
                      <div style={{ display: "none" }}>
                        <input
                          type="text"
                          defaultValue={
                            "3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18"
                          }
                          ref={(input) => (this.mimetypeids = input)}
                          className="mimetype"
                        />
                        <input
                          type="text"
                          defaultValue={"2,4,5,8"}
                          ref={(input) => (this.midias = input)}
                          className="midias"
                        />
                      </div>
                      <div className="arq-comp__ctrls">
                        <button
                          type="date"
                          className="arq-comp__format-btn"
                          onClick={this.ShowChoiceFormat.bind(this)}
                        >
                          {this.state.defaultValueFormat}{" "}
                          <span className="material-icons">expand_more</span>
                        </button>
                        <ul
                          className={
                            this.state.buttonShowFormatsFile
                              ? "arq-comp__list arq-comp__format-list active"
                              : "arq-comp__list arq-comp__format-list"
                          }
                        >
                          <li
                            className="arq-comp__item"
                            onClick={(event) =>
                              this.choiceFormat(
                                event,
                                "3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18",
                                "Todos"
                              )
                            }
                          >
                            <span className="arq-comp__radio"></span> Todos
                          </li>
                          <li
                            className="arq-comp__item"
                            onClick={(event) =>
                              this.choiceFormat(event, "5", "PDF")
                            }
                          >
                            <span className="arq-comp__radio"></span> PDF
                          </li>
                          <li
                            className="arq-comp__item"
                            onClick={(event) =>
                              this.choiceFormat(event, "10,11,14", "DOC")
                            }
                          >
                            <span className="arq-comp__radio"></span> DOC
                          </li>
                          <li
                            className="arq-comp__item"
                            onClick={(event) =>
                              this.choiceFormat(event, "8,9", "XLS")
                            }
                          >
                            <span className="arq-comp__radio"></span> XLS
                          </li>
                          <li
                            className="arq-comp__item"
                            onClick={(event) =>
                              this.choiceFormat(event, "12,13", "PPT")
                            }
                          >
                            <span className="arq-comp__radio"></span> PPT
                          </li>
                          <li
                            className="arq-comp__item"
                            onClick={(event) =>
                              this.choiceFormat(event, "7", "ZIP")
                            }
                          >
                            <span className="arq-comp__radio"></span> ZIP
                          </li>
                          <li
                            className="arq-comp__item"
                            onClick={(event) =>
                              this.choiceFormat(event, "3,18", "Imagem")
                            }
                          >
                            <span className="arq-comp__radio"></span> Imagem
                          </li>
                          <li
                            className="arq-comp__item"
                            onClick={(event) =>
                              this.choiceFormat(event, "4,6,15,17", "Áudio")
                            }
                          >
                            <span className="arq-comp__radio"></span> Áudio
                          </li>
                          <li
                            className="arq-comp__item"
                            onClick={(event) =>
                              this.choiceFormat(event, "16", "Vídeo")
                            }
                          >
                            <span className="arq-comp__radio"></span> Vídeo
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="arq-comp__channel-panel">
                      <p className="arq-comp__text">Canal:</p>
                      <div className="arq-comp__ctrls">
                        <button
                          type="date"
                          onClick={this.ShowChoiceMidias.bind(this)}
                          className="arq-comp__channel-btn"
                        >
                          {this.state.defaultValueMidias}{" "}
                          <span className="material-icons">expand_more</span>
                        </button>
                        <ul
                          className={
                            this.state.buttonShowMidias
                              ? "arq-comp__list arq-comp__format-list active"
                              : "arq-comp__list arq-comp__format-list"
                          }
                        >
                          <li
                            className="arq-comp__item"
                            id="Todos"
                            onClick={(event) =>
                              this.choiceMidia(event, "5,4,2,8", "Todos")
                            }
                          >
                            <span id="Todos" className="arq-comp__radio"></span>{" "}
                            Todos
                          </li>
                          <li
                            className="arq-comp__item"
                            id="Whatsapp"
                            onClick={(event) =>
                              this.choiceMidia(event, "5", "Whatsapp")
                            }
                          >
                            <span
                              id="Whatsapp"
                              className="arq-comp__radio"
                            ></span>{" "}
                            Whatsapp
                          </li>
                          <li
                            className="arq-comp__item"
                            id="Telegram"
                            onClick={(event) =>
                              this.choiceMidia(event, "8", "Telegram")
                            }
                          >
                            <span
                              id="Telegram"
                              className="arq-comp__radio"
                            ></span>{" "}
                            Telegram
                          </li>
                          <li
                            className="arq-comp__item"
                            id="Facebook"
                            onClick={(event) =>
                              this.choiceMidia(event, "4", "Facebook")
                            }
                          >
                            <span
                              id="Facebook"
                              className="arq-comp__radio"
                            ></span>{" "}
                            Facebook
                          </li>
                          <li
                            className="arq-comp__item"
                            id="Webchat"
                            onClick={(event) =>
                              this.choiceMidia(event, "2", "Webchat")
                            }
                          >
                            <span
                              id="Webchat"
                              className="arq-comp__radio"
                            ></span>{" "}
                            Webchat
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="arq-comp__ctrls">
                      <button
                        className="arq-comp__search-btn"
                        onClick={(event) => this.buttonSearchFileCompart(event)}
                      >
                        Filtrar
                      </button>
                    </div>
                  </div>

                  <div className="arq-comp__content">
                    <div className="arq-comp__table">
                      <div className="arq-comp__t-head">
                        <div className="arq-comp__t-col1 sort-by__btn">
                          <i className="material-icons">sort_by_alpha</i>
                        </div>
                        <div className="arq-comp__t-col2">Nome:</div>
                        <div className="arq-comp__t-col3">Data:</div>
                        <div className="arq-comp__t-col4">Tamanho:</div>
                        <div className="arq-comp__t-col5">Canal:</div>
                      </div>
                      <div className="arq-comp__t-body">
                        {this.state.detailsFileShared.map((dfilesh) => (
                          <div
                            className="arq-comp__t-item"
                            id="01"
                            key={dfilesh.id}
                            onClick={(event) =>
                              this.showExpandVisual(event, dfilesh.id)
                            }
                          >
                            <div
                              className={
                                this.state.optionsActionsFile.indexOf(
                                  dfilesh.id
                                ) != -1
                                  ? "arq-comp__t-item__context id-01 active"
                                  : "arq-comp__t-item__context id-01"
                              }
                            >
                              <div className="context__label special">
                                <a
                                  className="context__content"
                                  href={
                                    connection_platform.type_connect +
                                    "://" +
                                    ipcurrent +
                                    dfilesh.mensagem
                                  }
                                  target="_blank"
                                  download
                                >
                                  <span className="material-icons">
                                    visibility
                                  </span>
                                  <span className="context__text">
                                    Visualizar
                                  </span>
                                </a>
                              </div>
                              <div className="context__label">
                                <div
                                  className="context__content"
                                  onClick={(event) =>
                                    this.DonwloadFile(
                                      event,
                                      connection_platform.type_connect +
                                        "://" +
                                        ipcurrent +
                                        dfilesh.mensagem,
                                      dfilesh.mensagem
                                    )
                                  }
                                >
                                  <span className="material-icons">
                                    get_app
                                  </span>
                                  <span className="context__text">
                                    Fazer download
                                  </span>
                                </div>
                              </div>
                              {/* <div className="context__label">
                                <div className="context__content">
                                  <span className="material-icons">email</span>
                                  <span className="context__text">
                                    Enviar por email
                                  </span>
                                </div>
                              </div> */}
                            </div>
                            <div className="arq-comp__t-sort">
                              <span className="arq-comp__t-sort_ft">
                                {dfilesh.formato}
                              </span>
                            </div>
                            <div className="arq-comp__t-name">
                              Arquivo em {dfilesh.formato}
                            </div>
                            <div className="arq-comp__t-date">
                              {dfilesh.data_envio}
                            </div>
                            {(() => {
                              var url =
                                connection_platform.type_connect +
                                "://" +
                                ipcurrent +
                                dfilesh.mensagem;
                              {
                                dbfileSize(dfilesh.filesize);
                              }
                            })()}
                            <div className="arq-comp__t-size">
                              {dbfileSize(dfilesh.filesize)}
                            </div>
                            <div className="arq-comp__t-channel">
                              {(() => {
                                if (dfilesh.idmidia === 5) {
                                  return (
                                    <img
                                      src={WHATSAPP}
                                      alt=""
                                      className="arq-comp__t-channel__icon"
                                    />
                                  );
                                } else if (dfilesh.idmidia === 4) {
                                  return (
                                    <img
                                      src="build/images/t-facebook.svg"
                                      alt=""
                                      className="arq-comp__t-channel__icon"
                                    />
                                  );
                                } else if (dfilesh.idmidia === 2) {
                                  return (
                                    <img
                                      src={WEBCHAT}
                                      alt=""
                                      className="arq-comp__t-channel__icon"
                                    />
                                  );
                                }
                              })()}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </main>
            </div>
          </div>
        </div>

        {/* Fim do Modal Arquivos Compartilhados */}

        {/* Modal de Historico */}

        <div
          className="modal micromodal-slide"
          id="modal__historico-atendimento-queue"
          aria-hidden="true"
          role="dialog"
        >
          <div className="modal__overlay" tabIndex="-1">
            <div
              className="modal__container"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal__historico-atendimento__title"
            >
              <header className="modal__header">
                <h2
                  className="modal__title"
                  id="modal__historico-atendimento__title"
                >
                  Interações
                </h2>
                <button
                  className="modal__close"
                  aria-label="Close modal"
                  data-micromodal-close
                ></button>
              </header>
              <main
                className="modal__content"
                id="modal__historico-atendimento__content"
              >
                <div className="hist-atd__info">
                  <div className="hist-atd__info-items">
                    <p className="hist-atd__name  is-poppins">
                      {createJSON(this.state.cliente)}
                    </p>
                    <i className="material-icons hist-atd__icon">
                      question_answer
                    </i>{" "}
                    <span className="hist-atd__info-text">
                      Total de{" "}
                      <span className="hist-atd__counter">
                        {this.state.totalhistory}
                      </span>{" "}
                      interações&#x28;s&#x29;
                    </span>
                  </div>
                  {(() => {
                    if (InfoUsers.permdownload === true) {
                      return (
                        <div className="hist-atd__info-pdf">
                          <a onClick={this.exportPDFWithMethod}>
                            <img src={ICONPDFEXPORT} />
                            Exportar PDF
                          </a>
                        </div>
                      );
                    }
                  })()}
                </div>
                <div className="hist-atd__ctrls">
                  <p className="hist-atd__text">Período</p>
                  <span className="hist-atd__span">De:</span>
                  <input
                    type="datetime-local"
                    defaultValue={this.timedefaultinitqueue}
                    ref={(input) => (this.datahistoryinitqueue = input)}
                    className="hist-atd__end"
                    id="hist_start_queue"
                  />
                  <span className="hist-atd__span">Até:</span>
                  <input
                    type="datetime-local"
                    defaultValue={this.timedefaultfimqueue}
                    ref={(input) => (this.datahistoryfimqueue = input)}
                    className="hist-atd__end"
                    id="hist_end_queue"
                  />
                  <button
                    className="hist-atd__search-btn"
                    onClick={this.SearchHistoryQueue.bind(
                      this,
                      this.state.cdrid,
                      this.state.cliente
                    )}
                  >
                    Filtrar
                  </button>
                </div>
                <div className="hist-atd__content">
                  <div
                    className={
                      this.state.showHistory
                        ? "hist-atd__search active"
                        : "hist-atd__search"
                    }
                  >
                    <span
                      onClick={(event) => this.handleKeyUp("less")}
                      className="material-icons hist-atd__search-icon"
                    >
                      expand_less
                    </span>
                    <span
                      onClick={(event) => this.handleKeyUp("more")}
                      className="material-icons hist-atd__search-icon"
                    >
                      expand_more
                    </span>
                    <input
                      onChange={(event) =>
                        this.setState({
                          searchText: event.target.value,
                          arrowterm: 0,
                        })
                      }
                      type="text"
                      className="hist-atd__search-input"
                      placeholder="Pesquisar..."
                    />
                    <button
                      onClick={this.SearchInHistory.bind(this)}
                      className="hist-atd__search-btn hist-atd__search-btn--two"
                    >
                      Concluir
                    </button>
                  </div>
                  <div className="hist-atd__channel-info">
                    <img
                      className="hist-atd__channel-info-icon"
                      style={{ display: "none" }}
                      src={WHATSAPP}
                      alt=""
                      width="20"
                      height="20"
                    />
                    <div className="hist-atd__channel-info-time">
                      Interações
                    </div>
                  </div>
                  <div
                    className="hist-atd__wrapper"
                    onScroll={this.handleScroll}
                  >
                    <div className="hist-atd__channel">
                      <div className="hist-atd__channel-chat active">
                        {this.state.history.map((history) => (
                          <div
                            key={history.id}
                            className={
                              history.agente === true
                                ? "message right"
                                : "message left"
                            }
                          >
                            {(() => {
                              dia = history.diaenvio;
                              mes = history.mesenvio;
                              ano = history.anoenvio;
                              mes = meses.indexOf(mes);
                              dia = dia + " de " + meses[mes - 1];
                              if (
                                ano < history.anoenvio ||
                                ano > history.anoenvio
                              )
                                dia = dia + " de " + history.anoenvio;
                              if (dia != auxdia) {
                                dia = dia;
                                auxdia = dia;
                              } else {
                                auxdia = dia;
                                dia = "";
                              }
                            })()}
                            <div id={history.id} className="time">
                              {dia}
                            </div>
                            <div className="bubble" id={"queue_" + history.id}>
                              {(() => {
                                if (history.replyid > 0) {
                                  var text = "";
                                  var array = [];
                                  var posit = "";
                                  checkreply = true;

                                  array = this.state.history.filter(
                                    (msg) =>
                                      parseInt(msg.id) ===
                                      parseInt(history.replyid)
                                  );
                                  if (array.length !== 0 && array) {
                                    posit = array[0].author;
                                    if (array[0].mimetypeid !== 1) {
                                      var url = array[0].messagem;
                                      url = url.substring(
                                        url.lastIndexOf(".") + 1
                                      );
                                      switch (url.toLowerCase()) {
                                        case "jpeg":
                                        case "png":
                                        case "jpg": {
                                          return (
                                            <a
                                              href={"#queue_" + history.replyid}
                                            >
                                              <div className="reply-message active">
                                                <div className="reply-message__name">
                                                  {posit === "Me"
                                                    ? "Você"
                                                    : createJSON(
                                                        this.state.cliente
                                                      )}
                                                </div>
                                                <div className="reply-message__text">
                                                  <img
                                                    src={FOTO}
                                                    alt=""
                                                    width="15"
                                                  />{" "}
                                                  Imagem
                                                </div>
                                              </div>
                                            </a>
                                          );
                                        }
                                        case "pdf":
                                          return (
                                            <a
                                              href={"#queue_" + history.replyid}
                                            >
                                              <div className="reply-message active">
                                                <div className="reply-message__name">
                                                  {posit === "Me"
                                                    ? "Você"
                                                    : createJSON(
                                                        this.state.cliente
                                                      )}
                                                </div>
                                                <div className="reply-message__text">
                                                  <img
                                                    src={DOC}
                                                    alt=""
                                                    width="15"
                                                  />{" "}
                                                  PDF
                                                </div>
                                              </div>
                                            </a>
                                          );
                                        case "xls":
                                        case "xlsx":
                                        case "xlsm":
                                        case "doc":
                                        case "docx":
                                        case "ppt":
                                        case "pptx": {
                                          return (
                                            <a
                                              href={"#queue_" + history.replyid}
                                            >
                                              <div className="reply-message active">
                                                <div className="reply-message__name">
                                                  {posit === "Me"
                                                    ? "Você"
                                                    : createJSON(
                                                        this.state.cliente
                                                      )}
                                                </div>
                                                <div className="reply-message__text">
                                                  <img
                                                    src={DOC}
                                                    alt=""
                                                    width="15"
                                                  />{" "}
                                                  DOC
                                                </div>
                                              </div>
                                            </a>
                                          );
                                        }
                                        case "wav":
                                        case "mp3":
                                        case "ogg":
                                        case "mpeg": {
                                          return (
                                            <a
                                              href={"#queue_" + history.replyid}
                                            >
                                              <div className="reply-message active">
                                                <div className="reply-message__name">
                                                  {posit === "Me"
                                                    ? "Você"
                                                    : createJSON(
                                                        this.state.cliente
                                                      )}
                                                </div>
                                                <div className="reply-message__text">
                                                  <img
                                                    src={AUDIO}
                                                    alt=""
                                                    width="12"
                                                  />{" "}
                                                  Áudio
                                                </div>
                                              </div>
                                            </a>
                                          );
                                        }
                                        case "mp4": {
                                          return (
                                            <a
                                              href={"#queue_" + history.replyid}
                                            >
                                              <div className="reply-message active">
                                                <div className="reply-message__name">
                                                  {posit === "Me"
                                                    ? "Você"
                                                    : createJSON(
                                                        this.state.cliente
                                                      )}
                                                </div>
                                                <div className="reply-message__text">
                                                  <img
                                                    src={VIDEO}
                                                    alt=""
                                                    width="15"
                                                  />{" "}
                                                  Vídeo
                                                </div>
                                              </div>
                                            </a>
                                          );
                                        }
                                      }
                                    } else {
                                      text = array[0].messagem;
                                      if (text.length > 200)
                                        text = text.substr(0, 200) + "...";
                                      text = text.replace(/¿/gi, "\n");
                                      text = text.replace(/§/gi, "\r\n");
                                      return (
                                        <a href={"#queue_" + history.replyid}>
                                          <div className="reply-message active">
                                            <div className="reply-message__name">
                                              {posit === "Me"
                                                ? "Você"
                                                : createJSON(
                                                    this.state.cliente
                                                  )}
                                            </div>
                                            <div className="reply-message__text">
                                              {text}
                                            </div>
                                          </div>
                                        </a>
                                      );
                                    }
                                  }
                                }
                                //}
                              })()}

                              <div className="bubble-user-name">
                                {checkreply === false
                                  ? history.agente === false
                                    ? createJSON(this.state.cliente)
                                    : history.username
                                  : null}
                              </div>
                              <div className="text">
                                {(() => {
                                  let caption = history.caption;
                                  if (caption == "null" || caption == null) {
                                    caption = "";
                                  } else {
                                    caption = caption.replace(/\\n/g, "\r\n");
                                  }
                                  var positmessage1 = "";
                                  var positmessage2 = "";
                                  if (history.is_from_agent === true) {
                                    positmessage1 = " right";
                                  }
                                  checkreply = false;
                                  if (history.mimetypeid == "1") {
                                    var mensagem_tratada = tratarMSG(
                                      history.messagem
                                    );
                                    mensagem_tratada = mensagem_tratada.replace(
                                      /\\n/gi,
                                      "\r\n"
                                    );
                                    return (
                                      <div>
                                        <Highlighter
                                          highlightClassName="YourHighlightClass"
                                          searchWords={searchWords}
                                          autoEscape={true}
                                          textToHighlight={mensagem_tratada}
                                          sanitize={latinize}
                                        />
                                        <span className="text__end-spacing"></span>
                                      </div>
                                    );
                                  } else {
                                    if (history.mimetypeid == "2") {
                                      if (isJson(history.messagem) === true) {
                                        let json = JSON.parse(history.messagem);
                                        let options = json.options;
                                        let i = 1;
                                        var opcoes = [];
                                        for (i in options) {
                                          opcoes.push(
                                            i + " - " + options[i][1]
                                          );
                                        }
                                        return (
                                          <div>
                                            <Highlighter
                                              highlightClassName="YourHighlightClass"
                                              searchWords={searchWords}
                                              autoEscape={true}
                                              textToHighlight={
                                                json.msg + " \r\n "
                                              }
                                              sanitize={latinize}
                                            />
                                            <Highlighter
                                              highlightClassName="YourHighlightClass"
                                              searchWords={searchWords}
                                              autoEscape={true}
                                              textToHighlight={opcoes.join(
                                                "  \r\n  "
                                              )}
                                              sanitize={latinize}
                                            />
                                            <span className="text__end-spacing"></span>
                                          </div>
                                        );
                                      } else {
                                        return (
                                          <div>
                                            <Highlighter
                                              highlightClassName="YourHighlightClass"
                                              searchWords={searchWords}
                                              autoEscape={true}
                                              textToHighlight={history.messagem}
                                            />
                                            <span className="text__end-spacing"></span>
                                          </div>
                                        );
                                      }
                                    } else if (history.mimetypeid == "30") {
                                      if (isJson(history.messagem) === true) {
                                        let json = JSON.parse(history.messagem);
                                        let options = json.options;
                                        let i = 1;
                                        var opcoes = [];
                                        for (i in options) {
                                          opcoes.push(
                                            i + " - " + options[i][1]
                                          );
                                        }
                                        if (json.MSG) {
                                          return (
                                            <div>
                                              <Highlighter
                                                highlightClassName="YourHighlightClass"
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={
                                                  json.MSG + " \r\n "
                                                }
                                                sanitize={latinize}
                                              />
                                              <Highlighter
                                                highlightClassName="YourHighlightClass"
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={opcoes.join(
                                                  "  \r\n  "
                                                )}
                                                sanitize={latinize}
                                              />
                                              <span className="text__end-spacing"></span>
                                            </div>
                                          );
                                        } else if (json.URL) {
                                          return (
                                            <div>
                                              <Highlighter
                                                highlightClassName="YourHighlightClass"
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={
                                                  json.URL + " \r\n "
                                                }
                                                sanitize={latinize}
                                              />
                                              <Highlighter
                                                highlightClassName="YourHighlightClass"
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={opcoes.join(
                                                  "  \r\n  "
                                                )}
                                                sanitize={latinize}
                                              />
                                              <span className="text__end-spacing"></span>
                                            </div>
                                          );
                                        }
                                      }
                                    } else if (
                                      history.mimetypeid == "3" ||
                                      history.mimetypeid == "4" ||
                                      history.mimetypeid == "5" ||
                                      history.mimetypeid >= "6"
                                    ) {
                                      let separador =
                                        history.messagem.split(".");
                                      switch (separador[1]) {
                                        case "jpeg":
                                        case "png":
                                        case "PNG":
                                        case "jpg":
                                          return (
                                            <div className="bubble-media">
                                              <div
                                                className="bubble-media__image"
                                                onClick={(e) =>
                                                  this.VerifierImage(
                                                    e,
                                                    connection_platform.type_connect +
                                                      "://" +
                                                      ipcurrent +
                                                      history.messagem,
                                                    "history"
                                                  )
                                                }
                                              >
                                                {this.state.isOpen && (
                                                  <Lightbox
                                                    mainSrc={
                                                      this.state.urlimage
                                                    }
                                                    onCloseRequest={(e) =>
                                                      this.CloseImage(
                                                        e,
                                                        "history"
                                                      )
                                                    }
                                                  />
                                                )}
                                                <img
                                                  src={
                                                    connection_platform.type_connect +
                                                    "://" +
                                                    ipcurrent +
                                                    history.messagem
                                                  }
                                                  alt=""
                                                />
                                              </div>
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={JPG}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    Nome do Arquivo
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {dbfileSize(
                                                        history.filesize
                                                      )}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {""}
                                                    </span>
                                                  </div>
                                                </span>
                                                {(() => {
                                                  if (
                                                    InfoUsers.permdownload ===
                                                    true
                                                  ) {
                                                    return (
                                                      <div className="bubble-media__download">
                                                        <a
                                                          href={
                                                            connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            history.messagem
                                                          }
                                                          target="_blank"
                                                          download
                                                          className="bubble-media__btnDownload"
                                                        >
                                                          <i className="material-icons">
                                                            get_app
                                                          </i>
                                                        </a>
                                                      </div>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            </div>
                                          );
                                          break;
                                        case "pdf":
                                          return (
                                            <div className="bubble-media">
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={PDF}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    Nome do Arquivo
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {dbfileSize(
                                                        history.filesize
                                                      )}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {""}
                                                    </span>
                                                  </div>
                                                </span>
                                                {(() => {
                                                  if (
                                                    InfoUsers.permdownload ===
                                                    true
                                                  ) {
                                                    return (
                                                      <div className="bubble-media__download">
                                                        <a
                                                          href={
                                                            connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            history.messagem
                                                          }
                                                          target="_blank"
                                                          download
                                                          className="bubble-media__btnDownload"
                                                        >
                                                          <i className="material-icons">
                                                            get_app
                                                          </i>
                                                        </a>
                                                      </div>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            </div>
                                          );
                                          break;
                                        case "xls":
                                        case "xlsx":
                                        case "xlsm":
                                        case "doc":
                                        case "docx":
                                        case "ppt":
                                        case "pptx":
                                          return (
                                            <div className="bubble-media">
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={XLS}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    Nome do Arquivo
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {dbfileSize(
                                                        history.filesize
                                                      )}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {""}
                                                    </span>
                                                  </div>
                                                </span>
                                                {(() => {
                                                  if (
                                                    InfoUsers.permdownload ===
                                                    true
                                                  ) {
                                                    return (
                                                      <div className="bubble-media__download">
                                                        <a
                                                          href={
                                                            connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            history.messagem
                                                          }
                                                          target="_blank"
                                                          download
                                                          className="bubble-media__btnDownload"
                                                        >
                                                          <i className="material-icons">
                                                            get_app
                                                          </i>
                                                        </a>
                                                      </div>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            </div>
                                          );
                                          break;
                                        case "wav":
                                        case "mp3":
                                        case "ogg":
                                        case "mpeg":
                                          return (
                                            <div className="bubble-media">
                                              <div className="bubble-media__playerBar">
                                                <audio controls>
                                                  <source
                                                    src={
                                                      connection_platform.type_connect +
                                                      "://" +
                                                      ipcurrent +
                                                      history.messagem
                                                    }
                                                    type="audio/ogg"
                                                  />
                                                  <source
                                                    src={
                                                      connection_platform.type_connect +
                                                      "://" +
                                                      ipcurrent +
                                                      history.messagem
                                                    }
                                                    type="audio/mpeg"
                                                  />
                                                  Your browser.
                                                </audio>
                                              </div>
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={MP3}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    Nome do Arquivo
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {dbfileSize(
                                                        history.filesize
                                                      )}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {""}
                                                    </span>
                                                  </div>
                                                </span>
                                                {(() => {
                                                  if (
                                                    InfoUsers.permdownload ===
                                                    true
                                                  ) {
                                                    return (
                                                      <div className="bubble-media__download">
                                                        <a
                                                          href={
                                                            connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            history.messagem
                                                          }
                                                          target="_blank"
                                                          download
                                                          className="bubble-media__btnDownload"
                                                        >
                                                          <i className="material-icons">
                                                            get_app
                                                          </i>
                                                        </a>
                                                      </div>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            </div>
                                          );
                                          break;
                                        case "mp4":
                                          return (
                                            <div className="bubble-media">
                                              <div className="bubble-media__video">
                                                <video
                                                  className="bubble-media__video-frame"
                                                  controls
                                                >
                                                  <source
                                                    className="bubble-media__video-file"
                                                    src={
                                                      connection_platform.type_connect +
                                                      "://" +
                                                      ipcurrent +
                                                      history.messagem
                                                    }
                                                    type="video/mp4"
                                                  />
                                                  Seu navegador nao suporta esse
                                                  tipo de arquivo.
                                                </video>
                                              </div>
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={AVI}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    Nome do Arquivo
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {dbfileSize(
                                                        history.filesize
                                                      )}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {""}
                                                    </span>
                                                  </div>
                                                </span>
                                                {(() => {
                                                  if (
                                                    InfoUsers.permdownload ===
                                                    true
                                                  ) {
                                                    return (
                                                      <div className="bubble-media__download">
                                                        <a
                                                          href={
                                                            connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            history.messagem
                                                          }
                                                          target="_blank"
                                                          download
                                                          className="bubble-media__btnDownload"
                                                        >
                                                          <i className="material-icons">
                                                            get_app
                                                          </i>
                                                        </a>
                                                      </div>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            </div>
                                          );
                                          break;
                                        default:
                                          if (
                                            history.messagem.indexOf("https") >
                                              -1 &&
                                            history.messagem !== ""
                                          ) {
                                            if (
                                              parseInt(history.mimetypeid) ===
                                                16 ||
                                              parseInt(history.mimetypeid) ===
                                                41
                                            ) {
                                              return (
                                                <div className="bubble-media">
                                                  <div className="bubble-media__video">
                                                    <video
                                                      className="bubble-media__video-frame"
                                                      controls
                                                    >
                                                      <source
                                                        className="bubble-media__video-file"
                                                        src={history.messagem}
                                                        type="video/mp4"
                                                      />
                                                      Seu navegador nao suporta
                                                      esse tipo de arquivo.
                                                    </video>
                                                  </div>
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType">
                                                      <img
                                                        className="bubble-media__fileIcon"
                                                        src={AVI}
                                                        alt=""
                                                      />
                                                    </span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            history.filesize
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>
                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                history.messagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              );
                                            } else if (
                                              parseInt(history.mimetypeid) === 1
                                            ) {
                                              var mensagem_tratada = tratarMSG(
                                                history.messagem
                                              );
                                              mensagem_tratada =
                                                mensagem_tratada.replace(
                                                  /\\n/gi,
                                                  "\r\n"
                                                );
                                              return (
                                                <div>
                                                  <Highlighter
                                                    highlightClassName="YourHighlightClass"
                                                    searchWords={searchWords}
                                                    autoEscape={true}
                                                    textToHighlight={
                                                      mensagem_tratada
                                                    }
                                                    sanitize={latinize}
                                                  />
                                                  <span className="text__end-spacing"></span>
                                                </div>
                                              );
                                            } else if (
                                              parseInt(history.mimetypeid) ===
                                                5 ||
                                              parseInt(history.mimetypeid) ===
                                                7 ||
                                              parseInt(history.mimetypeid) ===
                                                8 ||
                                              parseInt(history.mimetypeid) ===
                                                9 ||
                                              parseInt(history.mimetypeid) ===
                                                10 ||
                                              parseInt(history.mimetypeid) ===
                                                11 ||
                                              parseInt(history.mimetypeid) ===
                                                12 ||
                                              parseInt(history.mimetypeid) ===
                                                13 ||
                                              parseInt(history.mimetypeid) ===
                                                14
                                            ) {
                                              return (
                                                <div className="bubble-media">
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType"></span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            history.filesize
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>
                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                history.messagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              );
                                            } else if (
                                              parseInt(history.mimetypeid) ===
                                                4 ||
                                              parseInt(history.mimetypeid) ===
                                                6 ||
                                              parseInt(history.mimetypeid) ===
                                                15 ||
                                              parseInt(history.mimetypeid) ===
                                                17 ||
                                              parseInt(history.mimetypeid) ===
                                                21 ||
                                              parseInt(history.mimetypeid) ===
                                                25 ||
                                              parseInt(history.mimetypeid) ===
                                                26 ||
                                              parseInt(history.mimetypeid) ===
                                                27 ||
                                              parseInt(history.mimetypeid) ===
                                                28 ||
                                              parseInt(history.mimetypeid) ===
                                                40
                                            ) {
                                              return (
                                                <div className="bubble-media">
                                                  <div className="bubble-media__playerBar">
                                                    <audio controls>
                                                      <source
                                                        src={history.messagem}
                                                        type="audio/ogg"
                                                      />
                                                      <source
                                                        src={history.messagem}
                                                        type="audio/mpeg"
                                                      />
                                                      Your browser.
                                                    </audio>
                                                  </div>
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType">
                                                      {/* <img className="bubble-media__fileIcon" src={MP3} alt="" /> */}
                                                    </span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            history.filesize
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>
                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                history.messagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              );
                                            } else if (
                                              parseInt(history.mimetypeid) ===
                                                3 ||
                                              parseInt(history.mimetypeid) ===
                                                18 ||
                                              parseInt(history.mimetypeid) ===
                                                19 ||
                                              parseInt(history.mimetypeid) ===
                                                20 ||
                                              parseInt(history.mimetypeid) ===
                                                22 ||
                                              parseInt(history.mimetypeid) ===
                                                23 ||
                                              parseInt(history.mimetypeid) ===
                                                24
                                            ) {
                                              return (
                                                <div className="bubble-media">
                                                  <div
                                                    className="bubble-media__image"
                                                    onClick={(e) =>
                                                      this.VerifierImage(
                                                        e,
                                                        history.messagem,
                                                        "history"
                                                      )
                                                    }
                                                  >
                                                    {this.state.isOpen && (
                                                      <Lightbox
                                                        mainSrc={
                                                          this.state.urlimage
                                                        }
                                                        onCloseRequest={(e) =>
                                                          this.CloseImage(
                                                            e,
                                                            "history"
                                                          )
                                                        }
                                                      />
                                                    )}
                                                    <img
                                                      src={history.messagem}
                                                      alt=""
                                                    />
                                                  </div>
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType"></span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            history.filesize
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>
                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                history.messagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              );
                                            }
                                          }
                                      }
                                    }
                                  }
                                })()}
                              </div>
                              <div className="text">
                                {(() => {
                                  let caption = history.caption;
                                  if (caption == "null" || caption == null) {
                                    caption = "";
                                  } else {
                                    caption = caption.replace(/\\n/g, "\r\n");
                                  }
                                  return caption;
                                })()}
                              </div>
                              <div className="bubble__info-content">
                                <div className="fav fav--inside fav--right">
                                  {/* <i className="material-icons fav-icon">star_border</i> */}
                                </div>
                                <div className="bubble__info-content__time">
                                  {history.horaenvio}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </main>

              <button
                className="hist-atd__fab"
                onClick={this.SearchInHistory.bind(this)}
              >
                <i className="material-icons">search</i>
              </button>

              <div className="modal__content__form__group modal__content__form__group--col-1">
                <a
                  className="modal__content__form__group__button modal__content__form__group__button--text"
                  data-micromodal-close
                >
                  <i className="material-icons" data-micromodal-close>
                    arrow_back
                  </i>
                  Voltar
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Fim do Modal de Historico */}
        <div
          className="modal micromodal-slide"
          id="modal__excluir"
          aria-hidden="true"
          role="dialog"
        >
          <DeleteCallModal
            deletecdrid={this.state.deletecdrid}
            deletequeueid={this.state.deletequeueid}
            mediaid={this.state.mediaid}
          />
        </div>
        <input type="hidden" id="simulation_click" name="simulation_click" />
        <div
          style={{
            position: "absolute",
            right: "-9999999999999999999999999px",
            top: 0,
          }}
        >
          <PDFExport
            ref={(component) => (this.pdfExportComponent = component)}
            paperSize="A4"
          >
            <PdfDocument
              history={this.state.history}
              cliente={this.state.cliente}
              datapdfinit={this.state.datapdfinit}
              datapdfend={this.state.datapdfend}
              numero={this.state.clientpdf}
            />
          </PDFExport>
        </div>
      </div>
    );
  }
  exportPDFWithMethod = () => {
    savePDF(ReactDOM.findDOMNode(this.pdfExportComponent), {
      paperSize: "A4",
      margin: 10,
      fileName: this.state.cliente + "_" + this.state.clientpdf + ".pdf",
    });
  };
  exportPDFWithComponent = () => {
    this.pdfExportComponent.save();
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Queue);
